export const roboticsResearchSources = {
  cmuModularSnake: {
    organization: "Carnegie Mellon University Robotics Institute",
    title: "Modular Snake Robots",
    published: "Project description; publication date not stated",
    url: "https://www.ri.cmu.edu/project/modular-snake-robots/",
    accessed: "2026-10-11"
  },
  sellafieldRobots: {
    organization: "Sellafield Ltd",
    title: "How are robot dogs helping clean up Sellafield?",
    published: "2026-01-29",
    url: "https://www.gov.uk/government/case-studies/how-are-robot-dogs-helping-clean-up-sellafield",
    accessed: "2026-10-11"
  },
  tepcoRetrieval: {
    organization: "TEPCO",
    title: "How is fuel debris retrieved?",
    published: "Official decommissioning explanation",
    url: "https://www.tepco.co.jp/en/hd/decommission/towards_decommissioning/Things_you_should_know_more_about_decommissioning/answer-19-e.html",
    accessed: "2026-10-11"
  },
  ifr: {
    organization: "International Federation of Robotics",
    title: "Industrial Robots",
    published: "Publication date not stated",
    url: "https://ifr.org/industrial-robots",
    accessed: "2026-07-10"
  },
  ros2: {
    organization: "Open Robotics",
    title: "ROS 2 Jazzy documentation",
    published: "Jazzy documentation, continuously maintained",
    url: "https://docs.ros.org/en/jazzy/",
    accessed: "2026-07-10"
  },
  isaacSim: {
    organization: "NVIDIA",
    title: "NVIDIA Isaac Sim",
    published: "Documentation, continuously maintained",
    url: "https://developer.nvidia.com/isaac/sim",
    accessed: "2026-07-10"
  },
  mujoco: {
    organization: "Google DeepMind",
    title: "MuJoCo documentation",
    published: "Documentation, continuously maintained",
    url: "https://mujoco.readthedocs.io/en/stable/overview.html",
    accessed: "2026-07-10"
  },
  oneXNeo: {
    organization: "1X Technologies",
    title: "NEO humanoid robot",
    published: "Official product page",
    url: "https://www.1x.tech/neo",
    accessed: "2026-07-10"
  },
  apptronikApollo: {
    organization: "Apptronik",
    title: "Apollo humanoid robot",
    published: "Official product page",
    url: "https://apptronik.com/apollo",
    accessed: "2026-07-10"
  },
  apptronikRobotPark: {
    organization: "Apptronik",
    title: "Welcome to Robot Park Where Apptronik’s Apollo Goes to Work",
    published: "2026-06-30",
    url: "https://apptronik.com/news-collection/welcome-to-robot-park-where-apptroniks-apollo-goes-to-work",
    accessed: "2026-07-23"
  },
  figure: {
    organization: "Figure AI",
    title: "Figure humanoid robot platform",
    published: "Official product page",
    url: "https://www.figure.ai/figure",
    accessed: "2026-07-10"
  },
  geminiRobotics: {
    organization: "Google DeepMind",
    title: "Gemini Robotics Bringing AI into the Physical World",
    published: "2025-03-25",
    url: "https://arxiv.org/abs/2503.20020",
    accessed: "2026-07-10"
  },
  grootN1: {
    organization: "NVIDIA Research",
    title: "GR00T N1 An Open Foundation Model for Generalist Humanoid Robots",
    published: "2025-03-18",
    url: "https://arxiv.org/abs/2503.14734",
    accessed: "2026-07-10"
  },
  softToolkit: {
    organization: "Harvard Biodesign Lab",
    title: "Soft Robotics Toolkit",
    published: "Resource collection, continuously maintained",
    url: "https://softroboticstoolkit.com/",
    accessed: "2026-07-10"
  },
  gecko: {
    organization: "Gecko Robotics",
    title: "AI and robotics for infrastructure inspection",
    published: "Official company page",
    url: "https://www.geckorobotics.com/",
    accessed: "2026-07-10"
  },
  shadowHand: {
    organization: "Shadow Robot Company",
    title: "Dexterous Hand Series",
    published: "Official product page",
    url: "https://shadowrobot.com/dexterous-hand-series/",
    accessed: "2026-07-10"
  },
  robotiq: {
    organization: "Robotiq",
    title: "Adaptive two-finger grippers",
    published: "Official product page",
    url: "https://robotiq.com/products/adaptive-grippers#Two-Finger-Gripper",
    accessed: "2026-07-10"
  },
  nasaPerseverance: {
    organization: "NASA",
    title: "Mars 2020 Perseverance Rover",
    published: "Mission page, updated during the active mission",
    url: "https://science.nasa.gov/mission/mars-2020-perseverance/",
    accessed: "2026-07-10"
  },
  icra2026: {
    organization: "IEEE Robotics and Automation Society",
    title: "ICRA 2026",
    published: "2026 event website",
    url: "https://2026.ieee-icra.org/",
    accessed: "2026-07-10"
  },
  automate: {
    organization: "Association for Advancing Automation",
    title: "Automate Show and Conference",
    published: "Official event website",
    url: "https://www.automateshow.com/",
    accessed: "2026-07-10"
  },
  robocup: {
    organization: "RoboCup Federation",
    title: "RoboCup leagues, events and research",
    published: "Official federation website",
    url: "https://www.robocup.org/",
    accessed: "2026-07-10"
  },
  carbon: {
    organization: "Carbon Robotics",
    title: "LaserWeeder",
    published: "Official product page",
    url: "https://carbonrobotics.com/laserweeder",
    accessed: "2026-07-10"
  },
  openBionics: {
    organization: "Open Bionics",
    title: "Hero Arm",
    published: "Official product page",
    url: "https://openbionics.com/hero-arm/",
    accessed: "2026-07-10"
  },
  intuitive: {
    organization: "Intuitive Surgical",
    title: "da Vinci surgical systems",
    published: "Official product overview",
    url: "https://www.intuitive.com/en-us/products-and-services/da-vinci",
    accessed: "2026-07-10"
  },
  universalRobots: {
    organization: "Universal Robots",
    title: "Collaborative robot products",
    published: "Official product overview",
    url: "https://www.universal-robots.com/products/",
    accessed: "2026-07-10"
  },
  fanuc: {
    organization: "FANUC America",
    title: "Industrial robot products and applications",
    published: "Official product overview",
    url: "https://www.fanucamerica.com/products/robot",
    accessed: "2026-07-10"
  },
  elevenLabs: {
    "organization": "ElevenLabs",
    "title": "AI voice, music, dubbing and agents platform",
    "published": "Official product page, continuously maintained",
    "url": "https://elevenlabs.io/",
    "accessed": "2026-07-23"
  },
  runwayGen4: {
    "organization": "Runway",
    "title": "Introducing Runway Gen-4",
    "published": "Official research and product page",
    "url": "https://runwayml.com/research/introducing-runway-gen-4",
    "accessed": "2026-07-23"
  },
  base44Changelog: {
    "organization": "Base44",
    "title": "Product changelog and Base 1 model updates",
    "published": "Official documentation, continuously maintained",
    "url": "https://docs.base44.com/changelog/product",
    "accessed": "2026-07-23"
  },
  perplexityComet: {
    "organization": "Perplexity",
    "title": "Comet Browser a personal AI assistant",
    "published": "Official product page, continuously maintained",
    "url": "https://www.perplexity.ai/comet",
    "accessed": "2026-07-23"
  },
  openaiCodex: {
    "organization": "OpenAI",
    "title": "Codex for software engineering",
    "published": "Official product page, continuously maintained",
    "url": "https://openai.com/codex/",
    "accessed": "2026-07-23"
  },
  googleVeo: {
    "organization": "Google DeepMind",
    "title": "Veo generative video model",
    "published": "Official model page, continuously maintained",
    "url": "https://deepmind.google/models/veo/",
    "accessed": "2026-07-23"
  },
  googleFlow: {
    "organization": "Google",
    "title": "Flow AI filmmaking tool",
    "published": "Official product announcement",
    "url": "https://blog.google/innovation-and-ai/products/google-flow-veo-ai-filmmaking-tool/",
    "accessed": "2026-07-23"
  },
  showrunner: {
    "organization": "Fable Studio",
    "title": "Showrunner AI entertainment platform",
    "published": "Official product page, continuously maintained",
    "url": "https://www.showrunner.xyz/",
    "accessed": "2026-07-23"
  },
  anthropicFableMythos: {
    "organization": "Anthropic",
    "title": "Claude Fable 5 and Claude Mythos 5",
    "published": "2026-06-09, with later access updates",
    "url": "https://www.anthropic.com/news/claude-fable-5-mythos-5",
    "accessed": "2026-07-23"
  },
  anthropicRedeploy: {
    "organization": "Anthropic",
    "title": "Redeploying Fable 5",
    "published": "2026-06-30",
    "url": "https://www.anthropic.com/news/redeploying-fable-5",
    "accessed": "2026-07-23"
  },
  openaiGpt56: {
    "organization": "OpenAI",
    "title": "GPT-5.6 Frontier intelligence that scales with your ambition",
    "published": "2026-07-09",
    "url": "https://openai.com/index/gpt-5-6/",
    "accessed": "2026-07-23"
  },
  spaceXaiGrok45: {
    "organization": "SpaceXAI",
    "title": "Introducing Grok 4.5",
    "published": "2026-07-16",
    "url": "https://x.ai/news/grok-4-5",
    "accessed": "2026-07-23"
  },
  unitree: {
    "organization": "Unitree Robotics",
    "title": "Official humanoid and quadruped robot product index",
    "published": "Official product website, continuously maintained",
    "url": "https://www.unitree.com/",
    "accessed": "2026-07-23"
  },
  engineAiT800: {
    "organization": "EngineAI",
    "title": "T800 humanoid robot",
    "published": "Official product page",
    "url": "https://en.engineai.com.cn/product-t800.html",
    "accessed": "2026-10-11"
  },
  lingbotWorld2: {
    "organization": "Robbyant Research",
    "title": "LingBot-World 2.0 Embodied world modeling",
    "published": "2026 research preprint",
    "url": "https://arxiv.org/abs/2607.07534",
    "accessed": "2026-07-23"
  },
  robbyantGithub: {
    "organization": "Robbyant",
    "title": "Open-source embodied intelligence repositories",
    "published": "Official GitHub organization, continuously maintained",
    "url": "https://github.com/Robbyant",
    "accessed": "2026-07-23"
  },
  roboticSkinPaper: {
    "organization": "Robotics researchers",
    "title": "Adaptive Electronic Skin Sensitivity for Safe Human-Robot Interaction",
    "published": "2024 preprint, revised 2025",
    "url": "https://arxiv.org/abs/2409.06369",
    "accessed": "2026-07-23"
  },
  wandercraft: {
    "organization": "Wandercraft",
    "title": "Calvin humanoid and mobility robotics",
    "published": "Official company website, continuously maintained",
    "url": "https://www.wandercraft.eu/",
    "accessed": "2026-07-23"
  },
  pollen: {
    "organization": "Pollen Robotics",
    "title": "Reachy humanoid robotics platform",
    "published": "Official company website, continuously maintained",
    "url": "https://www.pollen-robotics.com/",
    "accessed": "2026-07-23"
  },
  enchanted: {
    "organization": "Enchanted Tools",
    "title": "Mirokaï service robotics platform",
    "published": "Official company website, continuously maintained",
    "url": "https://www.enchanted.tools/",
    "accessed": "2026-07-23"
  },
  naoPaper: {
    "organization": "Aldebaran Robotics researchers",
    "title": "The NAO humanoid a combination of performance and affordability",
    "published": "2008 research paper",
    "url": "https://arxiv.org/abs/0807.3223",
    "accessed": "2026-07-23"
  },
  bristol: {
    "organization": "University of Bristol",
    "title": "Soft robotics research",
    "published": "Official university website, continuously maintained",
    "url": "https://www.bristol.ac.uk/",
    "accessed": "2026-07-23"
  },
  yaskawaPackaging: {
    "organization": "Yaskawa Motoman",
    "title": "Packaging automation and delta robots",
    "published": "Official application page, continuously maintained",
    "url": "https://www.motoman.com/en-us/solutions/packaging",
    "accessed": "2026-07-23"
  },
  ubtech: {
    "organization": "UBTECH Robotics",
    "title": "Humanoid and service robot platforms",
    "published": "Official company website, continuously maintained",
    "url": "https://www.ubtrobot.com/",
    "accessed": "2026-07-23"
  },
  palRobotics: {
    "organization": "PAL Robotics",
    "title": "Humanoid, mobile and service robots",
    "published": "Official company website, continuously maintained",
    "url": "https://pal-robotics.com/",
    "accessed": "2026-07-23"
  },
  kangarooPaper: {
    "organization": "Robotics researchers",
    "title": "KANGAROO lower-body humanoid modeling",
    "published": "2023 research preprint",
    "url": "https://arxiv.org/abs/2312.04161",
    "accessed": "2026-07-23"
  },
  teoPaper: {
    "organization": "Universidad Carlos III de Madrid researchers",
    "title": "TEO humanoid sign-language study",
    "published": "2019 research preprint",
    "url": "https://arxiv.org/abs/1901.05939",
    "accessed": "2026-07-23"
  },
  fdaDevices: {
    "organization": "U.S. Food and Drug Administration",
    "title": "Medical device overview and regulatory context",
    "published": "Official guidance, continuously maintained",
    "url": "https://www.fda.gov/medical-devices",
    "accessed": "2026-07-23"
  },
  surgeryStudy: {
    "organization": "Robotics and surgical researchers",
    "title": "In vivo feasibility study of humanoid robots in surgery",
    "published": "2026 research preprint",
    "url": "https://arxiv.org/abs/2607.07972",
    "accessed": "2026-07-23"
  },
  lapSurgie: {
    "organization": "Robotics researchers",
    "title": "LapSurgie teleoperated laparoscopy framework",
    "published": "2025 research preprint",
    "url": "https://arxiv.org/abs/2510.03529",
    "accessed": "2026-07-23"
  },
  agibot: {
    "organization": "AgiBot",
    "title": "Humanoid robot platforms",
    "published": "Official company website, continuously maintained",
    "url": "https://www.agibot.com/",
    "accessed": "2026-07-23"
  },
  riceNews: {
    "organization": "Rice University",
    "title": "University research news",
    "published": "Official university news site, continuously maintained",
    "url": "https://news.rice.edu/",
    "accessed": "2026-07-23"
  },
  nasaJohnson: {
    "organization": "NASA",
    "title": "Johnson Space Center",
    "published": "Official center website, continuously maintained",
    "url": "https://www.nasa.gov/johnson/",
    "accessed": "2026-07-23"
  },
  iso9001: {
    "organization": "International Organization for Standardization",
    "title": "ISO 9001 quality management systems",
    "published": "Official standards overview",
    "url": "https://www.iso.org/iso-9001-quality-management.html",
    "accessed": "2026-07-23"
  },
  nistManufacturing: {
    "organization": "National Institute of Standards and Technology",
    "title": "Manufacturing resources",
    "published": "Official resource collection, continuously maintained",
    "url": "https://www.nist.gov/manufacturing",
    "accessed": "2026-07-23"
  },
  aldebaran: {
    "organization": "Aldebaran",
    "title": "NAO and Pepper social robots",
    "published": "Official company website, continuously maintained",
    "url": "https://aldebaran.com/",
    "accessed": "2026-07-23"
  },
  djiNeo: {
    "organization": "DJI",
    "title": "DJI Neo product specifications",
    "published": "Official product page",
    "url": "https://www.dji.com/neo",
    "accessed": "2026-07-23"
  },
  djiMini4: {
    "organization": "DJI",
    "title": "DJI Mini 4 Pro product specifications",
    "published": "Official product page",
    "url": "https://www.dji.com/mini-4-pro",
    "accessed": "2026-07-23"
  },
  djiAir3s: {
    "organization": "DJI",
    "title": "DJI Air 3S product specifications",
    "published": "Official product page",
    "url": "https://www.dji.com/air-3s",
    "accessed": "2026-07-23"
  },
  djiAvata2: {
    "organization": "DJI",
    "title": "DJI Avata 2 product specifications",
    "published": "Official product page",
    "url": "https://www.dji.com/avata-2",
    "accessed": "2026-07-23"
  },
  djiMavic4: {
    "organization": "DJI",
    "title": "DJI Mavic 4 Pro product specifications",
    "published": "Official product page",
    "url": "https://www.dji.com/mavic-4-pro",
    "accessed": "2026-07-23"
  },
  faaUas: {
    "organization": "Federal Aviation Administration",
    "title": "Unmanned aircraft systems guidance",
    "published": "Official guidance, continuously maintained",
    "url": "https://www.faa.gov/uas",
    "accessed": "2026-07-23"
  },
  nioshConstruction: {
    "organization": "National Institute for Occupational Safety and Health",
    "title": "Construction equipment safety resources",
    "published": "Official resource collection, continuously maintained",
    "url": "https://www.cdc.gov/niosh/construction/",
    "accessed": "2026-07-23"
  },
};

const common = {
  reviewed: "2026-07-23",
  statusLabel: "Evidence review",
  limitationsTitle: "What the available evidence does not prove"
};

export const roboticsResearchEnhancements = {
  "/robotics": {
    ...common,
    heading: "How to verify a robotics claim",
    summary: "A useful robotics guide must connect software, hardware and operating conditions. A video alone cannot establish repeatability, autonomy or deployment readiness. This update adds a verification framework identify the robot body, sensing stack, control mode, task environment, operator involvement, failure recovery and evidence source before comparing systems.",
    verifiedFacts: [
      "Industrial robot categories describe mechanical configuration and intended application; they do not by themselves establish safety, autonomy or suitability for a specific process.",
      "ROS 2 supplies middleware and tooling for robot systems, while simulation environments such as Isaac Sim and MuJoCo test models under defined assumptions. Simulation results require real-robot validation.",
      "A deployment claim is stronger when it names the site, task, operating duration, intervention rate and acceptance criteria."
    ],
    evidenceLimits: [
      "A staged demonstration does not establish continuous operation.",
      "A language model issuing commands is not proof that low-level motion and safety control are autonomous.",
      "Performance cannot be compared without the same task, environment and measurement method."
    ],
    sourceIds: ["ifr", "ros2", "isaacSim", "mujoco"],
    related: [
      { label: "robot components and hardware", to: "/robot-components" },
      { label: "robot sensors and perception", to: "/robot-sensors" },
      { label: "robotics data collection", to: "/robotics-data-collection" }
    ]
  },
  "/robotics-topics": {
    ...common,
    heading: "Research topics organized by measurable system questions",
    summary: "The topic map now separates broad labels from questions that can be tested. Perception concerns what the robot detects and at what error rate. Planning concerns how a task is decomposed. Control concerns how commands become joint motion. Manipulation and locomotion require task-specific success, recovery and safety measures rather than general claims about intelligence.",
    verifiedFacts: [
      "ROS 2 documentation separates communication, execution, lifecycle and tooling concerns that are often blurred in high-level robotics articles.",
      "MuJoCo and Isaac Sim support physics-based experimentation, but model fidelity, contact parameters and sensor models affect transfer to hardware.",
      "Vision-language-action research combines perception, instructions and action generation; published benchmarks still use defined embodiments and task distributions."
    ],
    evidenceLimits: [
      "A benchmark score should not be generalized to untested robots or environments.",
      "Spatial reasoning output is not the same as verified collision-free execution.",
      "A research prototype can be valuable without being a commercial product."
    ],
    sourceIds: ["ros2", "mujoco", "geminiRobotics", "grootN1"],
    related: [
      { label: "Physical AI data guide", to: "/robotics-data-collection" },
      { label: "robotics software stack", to: "/robotics-software" }
    ]
  },
  "/robot-components": {
    ...common,
    heading: "Component selection must follow the task load",
    summary: "Motors, reducers, encoders, controllers, power electronics, sensors and end effectors cannot be selected independently. The required payload, reach, duty cycle, impact tolerance, backdrivability, precision and safety strategy determine the component stack. Public product pages are useful starting points, but integrators still need application testing and manufacturer documentation for the exact model.",
    verifiedFacts: [
      "Industrial arm suppliers publish different payload, reach, mounting and application ranges, so model names cannot be compared without the exact configuration.",
      "Collaborative operation depends on the complete application, tooling, speed, separation monitoring and risk assessment rather than the arm label alone.",
      "End effectors change payload, inertia, cable routing and collision behavior at the wrist."
    ],
    evidenceLimits: [
      "Catalog payload is not proof of reliable performance at every reach and speed.",
      "A component advertised as safety-rated does not make the full robot application safe by itself."
    ],
    sourceIds: ["ifr", "universalRobots", "fanuc", "robotiq"],
    related: [
      { label: "robotic arm joint components", to: "/robotic-arm-joint-components" },
      { label: "robot sensors guide", to: "/robot-sensors" }
    ]
  },
  "/robot-sensors": {
    ...common,
    heading: "Sensor specifications need environmental context",
    summary: "Camera resolution, LiDAR range, encoder precision and tactile sensitivity are not enough to predict field performance. Lighting, reflective surfaces, vibration, contamination, latency, calibration drift and occlusion determine whether a sensor can support a task. The revised guidance asks readers to separate the sensor data sheet from the complete perception and safety system.",
    verifiedFacts: [
      "Perception sensors feed estimation and planning layers; they do not directly guarantee correct action.",
      "Redundancy can improve fault detection, but only when the software recognizes disagreement and enters a defined safe state.",
      "Tactile sensing is most useful when control software can react to contact, slip or force changes within the task timing budget."
    ],
    evidenceLimits: [
      "Maximum range is not the same as reliable detection range for every object.",
      "Laboratory accuracy does not establish performance under dust, glare, vibration or repeated impacts."
    ],
    sourceIds: ["ros2", "oneXNeo", "shadowHand"],
    related: [
      { label: "robot components", to: "/robot-components" },
      { label: "humanoid robot hands", to: "/robot-types/humanoid-robot-hands" }
    ]
  },
  "/robot-management-software": {
    ...common,
    heading: "Fleet software is an operational layer, not robot intelligence",
    summary: "Robot management software schedules work, monitors status, records incidents and connects robots to business systems. It should not be confused with the onboard perception and control stack. A credible evaluation checks supported robot interfaces, map and mission handling, alerting, access control, audit logs, network loss behavior and the process for safe human intervention.",
    verifiedFacts: [
      "ROS 2 provides communication and lifecycle primitives, but a production fleet platform also needs deployment, observability and business integration functions.",
      "Robot-agnostic claims should be tested against named models, supported commands and failure behavior.",
      "A dashboard can display autonomy metrics only when the robot exposes trustworthy task and intervention data."
    ],
    evidenceLimits: [
      "Remote start and stop controls do not prove autonomous task execution.",
      "A cloud dashboard should not be treated as the only safety layer."
    ],
    sourceIds: ["ros2"],
    related: [
      { label: "robotics software", to: "/robotics-software" },
      { label: "robotics data collection", to: "/robotics-data-collection" }
    ]
  },
  "/robotic-arm-joint-components": {
    ...common,
    heading: "What determines a robotic joint assembly",
    summary: "A robotic arm joint is a coupled mechanical and control system. Motor torque, reduction ratio, bearing arrangement, encoder location, brake design, thermal path and cable routing affect backlash, stiffness, efficiency and service life. The correct architecture depends on payload, reach, speed, duty cycle and acceptable maintenance rather than a single maximum-torque figure.",
    verifiedFacts: [
      "The end effector and payload create joint loads that vary with arm pose and acceleration.",
      "Reducers trade speed for torque and introduce their own stiffness, efficiency, backlash and wear characteristics.",
      "Joint-level force or torque estimation requires calibrated sensing or a validated model; motor current alone is not always sufficient."
    ],
    evidenceLimits: [
      "A peak torque value does not establish continuous thermal capability.",
      "Position repeatability for a complete arm cannot be inferred from encoder resolution alone."
    ],
    sourceIds: ["fanuc", "universalRobots", "ifr"],
    related: [
      { label: "robot components and actuators", to: "/robot-components" },
      { label: "robotic grippers and end effectors", to: "/robot-types/robotic-grippers-and-end-effectors" }
    ]
  },
  "/nuclear-robots": {
    ...common,
    reviewed: "2026-10-11",
    heading: "Nuclear robotics requires radiation and recovery planning",
    summary: "Robots used for inspection, sampling, cutting or decommissioning face constraints that ordinary factory systems do not. Radiation can damage electronics and imaging systems. Dust, water, debris and limited access complicate locomotion and communications. Operations therefore combine remote control, specialized tooling, dose planning and recovery procedures for a disabled machine.",
    verifiedFacts: [
      "The task environment determines whether the system uses tracks, wheels, articulated arms, tethered power or remote communications.",
      "Teleoperation is common because operators must handle uncertain geometry and one-off interventions.",
      "A deployment plan needs a method to retrieve or abandon a failed robot without increasing worker exposure."
    ],
    evidenceLimits: [
      "A robot demonstrated in a mock-up is not automatically qualified for a radiological site.",
      "Radiation tolerance must be specified for components and expected accumulated dose."
    ],
    sourceIds: ["sellafieldRobots", "tepcoRetrieval", "ifr", "gecko"],
    related: [
      { label: "inspection and maintenance robots", to: "/robot-types/inspection-maintenance-robots" },
      { label: "nuclear decommissioning robots", to: "/robot-types/nuclear-decommissioning-robots" }
    ]
  },
  "/viral-robotics-topics": {
    ...common,
    heading: "How TechniaHQRobot labels a robot video",
    summary: "Robot videos are useful evidence only when the viewer can identify what was shown. The revised page asks for the robot name, date, source, task, environment, control mode, edit speed, number of visible repetitions and any human intervention. When those details are unavailable, the page labels the clip as a demonstration rather than treating it as a deployment result.",
    verifiedFacts: [
      "Official product pages may confirm hardware or intended use, but the exact video still needs its own context.",
      "Teleoperation, scripted sequences and learned policies can produce similar-looking footage while representing different technical achievements.",
      "A continuous uncut sequence provides stronger evidence of task completion than a montage, but it still does not establish long-term reliability."
    ],
    evidenceLimits: [
      "Apparent speed may be changed by editing.",
      "A single success does not provide a success rate or intervention rate.",
      "Objects and starting poses may have been prepared before filming."
    ],
    sourceIds: ["oneXNeo", "apptronikApollo", "figure"],
    related: [
      { label: "robotics news", to: "/robotics-news" },
      { label: "humanoid robots", to: "/robot-types/humanoid-robots" }
    ]
  },
  "/construction-robotics": {
    ...common,
    heading: "Construction robots are task-specific systems",
    summary: "Construction robotics covers layout, earthmoving, drilling, scanning, inspection, material handling and selected repetitive site tasks. The environment changes continuously, so localization, human exclusion zones, tool calibration and recovery planning matter as much as nominal speed. Commercial availability must be checked model by model instead of inferred from a prototype video.",
    verifiedFacts: [
      "Infrastructure inspection systems can combine mobile robots, sensors and software to create condition data for critical assets.",
      "Automated equipment still operates inside a site workflow with survey control, safety procedures and human supervision.",
      "Productivity comparisons require the same task scope, material, site constraints and quality threshold."
    ],
    evidenceLimits: [
      "A controlled test area does not reproduce every construction site condition.",
      "A robot completing one operation does not establish end-to-end autonomous construction."
    ],
    sourceIds: ["gecko", "ifr"],
    related: [
      { label: "construction robots", to: "/robot-types/construction-robots" },
      { label: "inspection robots", to: "/robot-types/inspection-maintenance-robots" }
    ]
  },
  "/micro-robotics": {
    ...common,
    heading: "Microrobotics depends on scale, actuation and observation method",
    summary: "Microrobotics includes devices small enough that conventional motors, batteries and sensors may no longer fit. Researchers use magnetic fields, light, fluid flow, electrostatic effects or specialized microfabrication. Claims should state whether motion occurred in air, liquid, tissue models or a microscope field and whether control was individual, collective or external.",
    verifiedFacts: [
      "At small scales, surface forces, fluid drag and fabrication tolerances can dominate behavior.",
      "External actuation may reduce onboard hardware but requires a controlled field or instrument around the robot.",
      "A laboratory experiment can demonstrate a mechanism without establishing clinical or industrial availability."
    ],
    evidenceLimits: [
      "Medical use should not be implied without safety, biocompatibility and regulatory evidence.",
      "A microscope video does not by itself establish position accuracy or payload."
    ],
    sourceIds: ["softToolkit"],
    related: [
      { label: "micro robots and nanorobots", to: "/robot-types/micro-robots-nanorobots" },
      { label: "biohybrid robots", to: "/robot-types/biohybrid-robots" }
    ]
  },
  "/drones-plus-robotics": null,
  "/entertainment-robotics": null,
  "/robotics-conferences": {
    ...common,
    heading: "Conference, exhibition and competition are different evidence sources",
    summary: "Research conferences publish reviewed work, trade shows display products and integrations, and competitions test systems under rules. The revised guide separates these formats so readers know whether a claim came from a paper, an exhibitor demonstration or a scored event. Dates, venues and submission status should always be verified on the organizer’s current page.",
    verifiedFacts: [
      "ICRA includes technical sessions, workshops, tutorials, competitions and an industry program.",
      "Automate is a commercial automation show and conference with exhibitors, training and industry sessions.",
      "RoboCup uses multiple leagues covering soccer, rescue, home, industrial and junior robotics."
    ],
    evidenceLimits: [
      "Exhibition presence is not proof of a customer deployment.",
      "A conference acceptance does not imply commercial readiness.",
      "Event dates can change and should be rechecked before travel."
    ],
    sourceIds: ["icra2026", "automate", "robocup"],
    related: [
      { label: "robotics events calendar", to: "/robotics-events" },
      { label: "robotics competitions", to: "/robotics-events/robotics-competitions" }
    ]
  },
  "/robotics-events": {
    ...common,
    heading: "Event records now emphasize official verification",
    summary: "Robotics event pages are most useful when they distinguish research programs, commercial exhibitions, competitions and startup demonstrations. Each listing should be checked against the organizer for current dates, venue, registration, submission deadlines and program changes. An event listing is not evidence that every announced robot or exhibitor will appear.",
    verifiedFacts: [
      "ICRA 2026 was scheduled for 1–5 June in Vienna and published separate program, registration and exhibitor information.",
      "Automate maintains separate show, conference, exhibitor and training records.",
      "RoboCup publishes league structures, events and research links through its federation website."
    ],
    evidenceLimits: [
      "TechniaHQRobot does not infer attendance from a sponsor logo or social post.",
      "Cancelled, completed and upcoming events must not be mixed without status labels."
    ],
    sourceIds: ["icra2026", "automate", "robocup"],
    related: [
      { label: "robotics conferences", to: "/robotics-events/conferences" },
      { label: "industrial automation events", to: "/robotics-events/industrial-automation-events" }
    ]
  },
  "/robotics-events/conferences": {
    ...common,
    heading: "What a robotics conference can verify",
    summary: "Conference programs provide papers, workshops, tutorials and technical discussions. They are strong sources for research methods and reported experiments, but they do not automatically prove product reliability or deployment. Readers should follow the paper, supplementary material, dataset and code when available rather than relying only on a stage summary.",
    verifiedFacts: ["ICRA separates regular sessions, workshops, tutorials, competitions and industry sessions.", "Submission and presentation status should be taken from the official conference record."],
    evidenceLimits: ["A paper result is bounded by its experimental protocol.", "A keynote statement is not a substitute for published evidence."],
    sourceIds: ["icra2026"],
    related: [{ label: "robotics conferences guide", to: "/robotics-conferences" }]
  },
  "/robotics-events/exhibitions": {
    ...common,
    heading: "How to read a robotics exhibition demo",
    summary: "Trade-show demonstrations are designed for short, repeatable presentation cycles. They can reveal hardware integration, interface design and current product direction, but booth conditions may use prepared objects, fixed lighting and frequent resets. A useful report records the task, control mode, run length and whether the same system is available to customers.",
    verifiedFacts: ["Automate separates exhibitor information from conference and training content.", "A booth demo should be linked to the exact company and product page when possible."],
    evidenceLimits: ["Exhibition footage does not establish unattended shift operation.", "A prototype display is not proof of commercial availability."],
    sourceIds: ["automate"],
    related: [{ label: "robot videos evidence guide", to: "/viral-robotics-topics" }]
  },
  "/robotics-events/humanoid-robot-events": {
    ...common,
    heading: "Humanoid events need control-mode labels",
    summary: "Humanoid demonstrations can combine scripted trajectories, teleoperation, learned manipulation and balance control. Event coverage should state which layer was demonstrated and whether the robot completed a task continuously. Hardware specifications should come from the maker, while performance claims should remain tied to the observed task and conditions.",
    verifiedFacts: ["Official humanoid product pages differ in payload, size, hand design, battery strategy and intended deployment.", "A remote-supervision mode must be distinguished from base autonomy."],
    evidenceLimits: ["Walking on a stage does not prove factory or home deployment.", "A polished montage does not provide an intervention rate."],
    sourceIds: ["oneXNeo", "apptronikApollo", "figure"],
    related: [{ label: "humanoid robots", to: "/robot-types/humanoid-robots" }]
  },
  "/robotics-events/industrial-automation-events": {
    ...common,
    heading: "Industrial events should connect robots to applications",
    summary: "Industrial automation shows bring together robot arms, cobots, vision, grippers, safety systems, controls and integrators. Product comparisons should use the complete cell and process, not the robot arm alone. Useful coverage identifies payload, reach, tooling, cycle conditions, safety method and integration requirements.",
    verifiedFacts: ["IFR separates industrial robot mechanical categories and application contexts.", "Automate presents both exhibition and conference material for automation users."],
    evidenceLimits: ["A maximum-speed booth cycle is not a validated production takt time.", "Collaborative hardware does not remove the need for application risk assessment."],
    sourceIds: ["ifr", "automate", "universalRobots"],
    related: [{ label: "industrial robots", to: "/robot-types/industrial-robots" }]
  },
  "/robotics-events/robotics-competitions": {
    ...common,
    heading: "Competition results must be read with the rulebook",
    summary: "Robotics competitions create repeatable tasks, scoring and shared constraints. They are valuable because systems face deadlines and comparison, but the result applies to that league, field and rule set. Reports should name the platform class, allowed operator input, resets, scoring method and whether simulation or physical hardware was used.",
    verifiedFacts: ["RoboCup publishes separate soccer, rescue, home, industrial and junior leagues.", "Each league tests a different combination of mobility, perception, interaction and task execution."],
    evidenceLimits: ["Winning a league does not establish performance outside its rules.", "Human setup and authorized interventions must be included in the interpretation."],
    sourceIds: ["robocup"],
    related: [{ label: "research robots", to: "/robot-types/research-robots" }]
  },
  "/robotics-events/startup-demo-days": {
    ...common,
    heading: "Startup demos need product-status disclosure",
    summary: "A startup demo can show a new mechanism, interface or task policy before a product is ready for sale. Coverage should identify the robot version, source of control, test environment, run length, funding or customer claims that are directly confirmed and the distinction between prototype, pilot, preproduction and commercial systems.",
    verifiedFacts: ["Official company pages are the preferred source for the current product name and intended use.", "Customer and production claims need a direct announcement or named deployment record."],
    evidenceLimits: ["A fundraising presentation is not a production audit.", "A pilot announcement does not disclose utilization, reliability or commercial terms unless the parties publish them."],
    sourceIds: ["apptronikApollo", "oneXNeo", "figure"],
    related: [{ label: "robotics companies", to: "/robotics-companies" }]
  },
  "/ai-news/google-gemini-robotics-spatial-reasoning-action": {
    ...common,
    heading: "Historical Gemini Robotics evidence and model boundaries",
    summary: "The original 2025 Gemini Robotics research report describes a vision-language-action model built on Gemini 2.0, with a related embodied-reasoning model. This historical report is separate from the Robotics 2 and ER 2 versions discussed above. The paper reports manipulation across defined robots, tasks and test conditions. These results should not be generalized to every embodiment or treated as proof of unrestricted real-world autonomy.",
    verifiedFacts: [
      "The report describes direct robot control through a vision-language-action model.",
      "Gemini Robotics-ER covers embodied reasoning outputs such as object detection, pointing, trajectory and grasp prediction.",
      "The experiments include fine-tuning and adaptation to specific capabilities and robot embodiments."
    ],
    evidenceLimits: ["The paper does not establish universal performance across untested robots.", "Reasoning predictions still require a safe control system and physical validation."],
    sourceIds: ["geminiRobotics"],
    related: [{ label: "Physical AI data collection", to: "/robotics-data-collection" }]
  },
  "/ai-news/nvidia-gr00t-robot-foundation-models-physical-ai": {
    ...common,
    heading: "GR00T N1 architecture and reported experiments",
    summary: "GR00T N1 is described by NVIDIA’s research team as an open foundation model for humanoid robots. The paper uses a dual-system architecture a vision-language module interprets the environment and instructions, while a diffusion-transformer module generates actions. Training combines real robot trajectories, human video and synthetic data, with experiments on defined simulation benchmarks and a Fourier GR-1 platform.",
    verifiedFacts: ["The model is a vision-language-action system with coupled high-level interpretation and action generation.", "The paper reports language-conditioned bimanual manipulation on the Fourier GR-1.", "Reported comparisons are tied to the paper’s benchmarks and data setup."],
    evidenceLimits: ["An open model release does not make every supported robot autonomous.", "Benchmark improvements do not establish factory reliability or safety certification."],
    sourceIds: ["grootN1", "isaacSim"],
    related: [{ label: "robotics data collection", to: "/robotics-data-collection" }]
  },
  "/robotics-news/22-countries-global-robotics": {
    ...common,
    heading: "Country comparisons need a consistent unit of analysis",
    summary: "A country can be strong in robot manufacturing, component supply, research, deployments or startup formation without leading every category. The revised context separates industrial robot installations from humanoid prototypes, university projects and service-robot companies. It avoids ranking countries from social visibility alone.",
    verifiedFacts: ["IFR industrial-robot statistics use defined installation and stock measures.", "Research conferences and competition participation capture different activity from commercial deployment."],
    evidenceLimits: ["A list of companies is not a market-share estimate.", "Public demonstrations can overrepresent countries with more active media teams."],
    sourceIds: ["ifr", "icra2026", "robocup"],
    related: [{ label: "robotics companies by country", to: "/robotics-companies" }]
  },
  "/robotics-news/build-first-robot-limited-budget": {
    ...common,
    heading: "A budget robot should start with a measurable task",
    summary: "The first design decision is the task, not the body shape. A small wheeled platform or fixed arm can teach sensing, control and software with fewer mechanical risks than a humanoid. The updated guide recommends defining success, selecting one sensor and actuator chain, logging failures and using simulation only where it reduces hardware iteration.",
    verifiedFacts: ["ROS 2 documentation provides a maintained path for nodes, topics, services and robot tooling.", "MuJoCo and Isaac Sim can test control and perception assumptions before hardware trials.", "A two-finger gripper is often easier to integrate and evaluate than an anthropomorphic hand."],
    evidenceLimits: ["Simulation does not remove calibration, friction, wiring and power problems.", "A low-cost prototype should not be presented as a safety-rated product."],
    sourceIds: ["ros2", "mujoco", "isaacSim", "robotiq"],
    related: [{ label: "robot components", to: "/robot-components" }, { label: "robot sensors", to: "/robot-sensors" }]
  },
  "/robotics-news/humanoid-robot-internal-hardware-breakdown": {
    ...common,
    heading: "Humanoid hardware must be read as a system",
    summary: "Humanoid robots distribute mass, power, sensing and computation across a body that must balance while manipulating objects. Public pages for NEO, Apollo and Figure disclose different subsets of size, payload, battery, actuation and hand information. Missing values should remain undisclosed rather than filled with estimates from video.",
    verifiedFacts: ["Apptronik publishes Apollo’s size, mass, payload and hot-swappable battery concept on its official page.", "1X describes tendon-driven actuation and separates base autonomy from its remote Expert Mode.", "Figure publishes platform specifications and product updates through its official site."],
    evidenceLimits: ["Published peak payload does not reveal task success rate.", "Internal images do not establish component life, thermal limits or maintenance interval."],
    sourceIds: ["apptronikApollo", "oneXNeo", "figure"],
    related: [{ label: "humanoid robots", to: "/robot-types/humanoid-robots" }, { label: "humanoid robot hands", to: "/robot-types/humanoid-robot-hands" }]
  },
  "/robotics-news/documented-humanoid-deployments-vs-demo-visibility-map": {
    ...common,
    heading: "Deployment evidence requires a named task and site",
    summary: "A humanoid deployment record is stronger than a demo when it identifies the customer or site, task, duration, supervision method and operational outcome. The map should therefore separate official pilots, internal tests, staged videos and announced intentions. Visibility on social media is not used as a proxy for fleet size or reliability.",
    verifiedFacts: ["Official product pages describe intended sectors and hardware, but deployment status needs a separate named announcement.", "Remote supervision and teleoperation should be counted as human involvement, not hidden inside an autonomy label."],
    evidenceLimits: ["An announced pilot does not disclose daily utilization or intervention rate unless published.", "No production quantity is inferred from factory footage or supplier statements."],
    sourceIds: ["apptronikApollo", "oneXNeo", "figure"],
    related: [{ label: "robotics companies", to: "/robotics-companies" }, { label: "robot videos", to: "/viral-robotics-topics" }]
  },
  "/robotics-news/apptronik-apollo-2-robot-park-data-factory": {
    ...common,
    heading: "What Robot Park confirms about Apollo 2 data collection",
    summary: "Apptronik’s June 30, 2026 release describes Robot Park as a nearly 90,000-square-foot Austin facility connected to additional workflows at Google DeepMind, Mercedes-Benz, GXO and other customer or partner sites. Apollo 2 appears in bipedal and wheeled-base configurations and collects data through a combination of teleoperation, autonomous execution and high-fidelity simulation. This is stronger evidence than a stage demo, but the announcement still does not publish fleet size, task-level success, intervention frequency, data volume or an independent reliability audit.",
    verifiedFacts: [
      "Apptronik identifies Apollo 2 as the current modular training platform and says it has served as the Robot Park workhorse for more than a year.",
      "The Austin facility is described as nearly 90,000 square feet and covers logistics, manufacturing, retail and customer-driven tasks.",
      "The company states that data workflows also operate at Google DeepMind and customer sites including Mercedes-Benz and GXO.",
      "Apptronik explicitly says the data mix combines teleoperation, autonomous execution and physics simulation.",
      "The wheeled configuration is positioned for easier integration with existing industrial mobile-robot safety standards, while the biped is used for more complex terrain and walking research.",
      "The collected data is intended to support Gemini Robotics research and the development of Apptronik’s future Apollo 3 commercial fleet."
    ],
    evidenceLimits: [
      "The release does not disclose the number of Apollo 2 units, hours collected, demonstrations retained or rejected, or the proportion produced by teleoperation versus autonomous execution.",
      "No task-level success rate, human intervention rate, uptime, maintenance interval or customer throughput result is published.",
      "The named customer and partner sites confirm data-collection activity, not unrestricted autonomous production deployment.",
      "Claims about continuous learning and future Apollo 3 performance remain company statements until measured commercial results are available."
    ],
    sourceIds: ["apptronikRobotPark", "apptronikApollo", "geminiRobotics"],
    related: [
      { label: "Physical AI data collection", to: "/robotics-data-collection" },
      { label: "Gemini Robotics models and evidence", to: "/robotics-news/gemini-robotics-models" },
      { label: "Documented humanoid deployments", to: "/robotics-news/documented-humanoid-deployments-vs-demo-visibility-map" }
    ]
  },
  "/robot-types/soft-robotics": {
    ...common,
    heading: "Soft robotics requires material and test details",
    summary: "Soft robots use compliant materials or structures to deform during actuation and contact. The Harvard Soft Robotics Toolkit documents design, fabrication, modeling, testing and control rather than treating softness as a single capability. Useful comparisons should state the actuator type, working fluid or cable, material, pressure or force range, cycle count and sensing method.",
    verifiedFacts: ["The toolkit includes downloadable designs, bills of materials, fabrication steps, modeling approaches and empirical tests.", "Soft grippers can conform to objects, but deformation complicates state estimation and precise control."],
    evidenceLimits: ["A gentle grasp demo does not establish durability or food-safe operation.", "Material compliance does not remove the need for force and failure testing."],
    sourceIds: ["softToolkit"],
    related: [{ label: "robotic grippers", to: "/robot-types/robotic-grippers-and-end-effectors" }]
  },
  "/robot-types/snake-robots": {
    ...common,
    reviewed: "2026-10-11",
    heading: "A documented modular snake mechanism",
    summary: "Carnegie Mellon's Modsnake project connects repeated modules into an articulated chain. This gives a concrete mechanism to examine alongside the proposed access checks above. The project description does not supply a general speed comparison with wheeled or tracked robots.",
    verifiedFacts: ["CMU describes each module as having one rotational degree of freedom.", "The project identifies climbing inside and outside pipes among the movements investigated."],
    evidenceLimits: ["A laboratory pipe or obstacle course does not represent every field surface.", "Locomotion footage without dimensions and run length cannot establish access capability."],
    sourceIds: ["cmuModularSnake"],
    related: [{ label: "pipeline inspection robots", to: "/robot-types/pipeline-and-sewer-inspection-robots" }]
  },
  "/robot-types/wall-climbing-robots": {
    ...common,
    heading: "Wall-climbing robots depend on surface and attachment method",
    summary: "Magnetic wheels, suction, vacuum, adhesive materials and mechanical gripping each work on different surfaces. A useful wall-climbing specification identifies material, curvature, contamination, vertical payload, cable or battery, transition behavior and what happens after power loss. Inspection value also depends on the sensor package and data workflow.",
    verifiedFacts: ["Gecko Robotics describes fleets of robots and sensors used to collect physical data from critical infrastructure.", "Inspection output becomes operationally useful when it is tied to asset location and condition records."],
    evidenceLimits: ["Performance on clean steel does not establish performance on painted, corroded or curved surfaces.", "A climbing demo does not prove the inspection sensor has required accuracy."],
    sourceIds: ["gecko"],
    related: [{ label: "inspection and maintenance robots", to: "/robot-types/inspection-maintenance-robots" }]
  },
  "/robot-types/space-robotics": {
    ...common,
    heading: "Space robots combine autonomy with delayed human control",
    summary: "Planetary rovers and orbital manipulators operate under communication delay, limited power and difficult maintenance. NASA’s Perseverance mission illustrates a deployed rover with a defined science objective, mission timeline, instruments and human operations team. Autonomy handles bounded navigation and instrument sequences while mission planning remains human-directed.",
    verifiedFacts: ["Perseverance landed in Jezero Crater on 18 February 2021 and remains an active mission.", "Its objectives include seeking signs of ancient microbial life and collecting rock and regolith samples.", "The mission page distinguishes the rover from Ingenuity, a technology-demonstration helicopter that completed 72 flights."],
    evidenceLimits: ["Planetary autonomy is not unrestricted decision-making.", "Earth testing cannot reproduce every thermal, radiation and terrain condition."],
    sourceIds: ["nasaPerseverance"],
    related: [{ label: "planetary rovers", to: "/robot-types/planetary-rovers" }, { label: "orbital robotic arms", to: "/robot-types/orbital-robotic-arms" }]
  },
  "/robot-types/humanoid-robot-hands": {
    ...common,
    heading: "Dexterous hands need task-level evidence",
    summary: "Finger count and degrees of freedom describe kinematics, not usable dexterity. A humanoid hand also needs force control, tactile sensing, backlash management, tendon or gear durability and a policy that reacts to slip and unexpected contact. The update compares only published systems and keeps undisclosed specifications blank.",
    verifiedFacts: ["1X describes NEO’s hand and tendon-driven actuation on its official product page.", "Shadow Robot sells dexterous hand platforms for research and development.", "Robotiq’s adaptive two-finger grippers represent a simpler industrial alternative for bounded grasping tasks."],
    evidenceLimits: ["A hand performing one prepared grasp does not establish general manipulation.", "Human-like shape does not prove human-level force, reliability or tactile resolution."],
    sourceIds: ["oneXNeo", "shadowHand", "robotiq"],
    related: [{ label: "1X NEO hand analysis", to: "/robotics-news/1x-neo-25-dof-tendon-driven-hands" }, { label: "robotic grippers", to: "/robot-types/robotic-grippers-and-end-effectors" }]
  },
  "/robot-types/robotic-grippers-and-end-effectors": {
    ...common,
    heading: "Choose the end effector from the object and process",
    summary: "Two-finger grippers, vacuum tools, magnetic tools, soft grippers and dexterous hands solve different problems. Selection depends on object geometry, surface, porosity, mass, tolerance to contact, required orientation, cycle time and changeover. The tool, wrist adapter, cables and object all count against the robot’s payload and dynamic limits.",
    verifiedFacts: ["Robotiq publishes adaptive grippers intended for common collaborative-robot handling tasks.", "Shadow Robot’s dexterous hands target research where many joints and human-like manipulation are required.", "Soft gripper designs require material, pressure and cycle testing."],
    evidenceLimits: ["Maximum grip force is not the only measure of grasp reliability.", "A dexterous hand is not automatically better than a simple gripper for repetitive production."],
    sourceIds: ["robotiq", "shadowHand", "softToolkit"],
    related: [{ label: "humanoid robot hands", to: "/robot-types/humanoid-robot-hands" }, { label: "robot components", to: "/robot-components" }]
  },
  "/ai-news/elevenlabs-ai-voice-music-ethics-entertainment": {
    ...common,
    heading: "What AI audio tools can do and where rights still apply",
    summary: "ElevenLabs now groups generated speech, voice cloning, dubbing, music, sound effects and conversational agents in one platform. That product breadth explains the commercial interest, but it does not remove the rights attached to a performer, recording or composition. A useful evaluation separates technical quality from permission who supplied the voice data, what license covers the output, whether the audience could mistake it for a real performance and how the creator documents consent.",
    verifiedFacts: [
      "ElevenLabs publicly offers tools for speech, music, sound effects, localization and monitored conversational agents.",
      "Synthetic audio can reduce narration and localization time, but a recognizable voice may involve contract, publicity, copyright or platform-policy questions beyond model capability."
    ],
    evidenceLimits: [
      "A high-fidelity voice sample does not prove that the underlying training or use was authorized.",
      "The platform feature list does not establish the legal status of every generated track in every jurisdiction."
    ],
    sourceIds: [
      "elevenLabs"
    ],
    related: [
      {
        "label": "AI news and model releases",
        "to": "/ai-news"
      },
      {
        "label": "AI and robotics research topics",
        "to": "/robotics-topics"
      }
    ]
  },
  "/ai-news/runway-gen4-consistent-ai-video-production": {
    ...common,
    heading: "Consistency is a workflow claim, not a guarantee for every shot",
    summary: "Runway describes Gen-4 as a media model designed to preserve characters, objects, locations and visual style across generated scenes by using reference images and instructions. That is more useful for production than a single attractive clip because editors need repeatable identities and coverage from multiple viewpoints. The practical test remains project-specific compare facial details, wardrobe, object geometry, lighting, motion continuity and editability across several generations, not one selected example.",
    verifiedFacts: [
      "Runway’s official Gen-4 page emphasizes world consistency, visual references and regenerated subjects from different perspectives.",
      "The same reference can support multiple shots, but each output still needs continuity review before it enters a finished sequence."
    ],
    evidenceLimits: [
      "Curated product examples do not provide an independent success rate for long sequences.",
      "Visual consistency does not establish physically correct motion, clean audio synchronization or production-ready rights clearance."
    ],
    sourceIds: [
      "runwayGen4"
    ],
    related: [
      {
        "label": "Google Veo and Flow analysis",
        "to": "/ai-news/google-veo-flow-ai-filmmaking-native-audio"
      },
      {
        "label": "AI news index",
        "to": "/ai-news"
      }
    ]
  },
  "/ai-news/base44-base1-ai-app-builders-design-slop": {
    ...common,
    heading: "A specialized builder still needs production review",
    summary: "Base44 positions Base 1 as an in-house model informed by patterns from applications built on its platform. The useful distinction is between generating a convincing interface and delivering a dependable product. Authentication rules, role permissions, data retention, error handling, accessibility, observability and export options determine whether an app survives real use. The page now treats visual originality as one criterion, not as proof that the generated system is secure or maintainable.",
    verifiedFacts: [
      "Base44 documents Base 1 through its own product changelog and presents the platform as a natural-language app builder.",
      "A domain-specific model can learn common platform structures, while the final application still inherits configuration and review requirements."
    ],
    evidenceLimits: [
      "A generated prototype does not disclose the quality of its authorization rules or data model.",
      "Claims about better design taste need repeatable comparisons across the same prompts and evaluation criteria."
    ],
    sourceIds: [
      "base44Changelog"
    ],
    related: [
      {
        "label": "OpenAI Codex and software agents",
        "to": "/ai-news/openai-codex-agentic-work-software-teams"
      },
      {
        "label": "AI news index",
        "to": "/ai-news"
      }
    ]
  },
  "/ai-news/perplexity-comet-ai-browser-delegated-search": {
    ...common,
    heading: "Delegated browsing increases both utility and attack surface",
    summary: "Comet places an assistant inside the browser, where it can work with pages, tabs and signed-in services. Perplexity’s official page describes delegated tasks such as inbox organization, shopping and travel planning. The same access that makes the browser useful also raises the cost of a mistake. Users need visible action previews, permission boundaries, confirmation before purchases or messages and resistance to instructions hidden inside a webpage.",
    verifiedFacts: [
      "Perplexity markets Comet for desktop and mobile platforms and presents it as a personal assistant for browser tasks.",
      "A browser agent can combine information across pages, but the user remains responsible for checking actions involving accounts, money or private data."
    ],
    evidenceLimits: [
      "A product demonstration does not establish immunity to prompt injection or malicious pages.",
      "Delegation quality varies with website structure, login state, regional availability and the exact action requested."
    ],
    sourceIds: [
      "perplexityComet"
    ],
    related: [
      {
        "label": "OpenAI Codex agent workflows",
        "to": "/ai-news/openai-codex-agentic-work-software-teams"
      },
      {
        "label": "AI news index",
        "to": "/ai-news"
      }
    ]
  },
  "/ai-news/openai-codex-agentic-work-software-teams": {
    ...common,
    heading: "The engineering value appears in reviewable repository changes",
    summary: "OpenAI presents Codex as a software-engineering agent that can work across ChatGPT, editors and terminals, with cloud environments, worktrees and parallel tasks. That moves the product beyond code completion, but it does not remove normal engineering controls. A team should measure accepted pull requests, test pass rates, regression rate, review time, rollback frequency and the amount of human correction rather than counting generated lines of code.",
    verifiedFacts: [
      "OpenAI’s Codex product page describes end-to-end tasks such as features, refactors and migrations, plus parallel agent workflows.",
      "Repository instructions, tests, isolated worktrees and human review can constrain changes and make failures easier to inspect."
    ],
    evidenceLimits: [
      "An agent completing a demo task does not establish reliability on an unfamiliar production repository.",
      "Parallel agents can create more output while also increasing merge conflicts, duplicated work and review load."
    ],
    sourceIds: [
      "openaiCodex"
    ],
    related: [
      {
        "label": "Base44 AI app builders",
        "to": "/ai-news/base44-base1-ai-app-builders-design-slop"
      },
      {
        "label": "AI news index",
        "to": "/ai-news"
      }
    ]
  },
  "/ai-news/google-veo-flow-ai-filmmaking-native-audio": {
    ...common,
    heading: "Film control should be evaluated shot by shot",
    summary: "Google connects Veo’s video generation with Flow, a filmmaking interface for prompts, references, camera direction and scene management. Native audio can reduce a separate post-production step, but generated dialogue, ambience and effects still need synchronization and rights review. A serious test should use a shot list and compare subject identity, camera movement, temporal continuity, sound timing and the ability to revise one element without rebuilding the entire scene.",
    verifiedFacts: [
      "Google presents Flow as a creative tool built around Veo models and filmmaking controls.",
      "The Veo model page documents video-generation capabilities, while final editorial continuity remains a human production decision."
    ],
    evidenceLimits: [
      "A short product example does not establish continuity across a full episode or film.",
      "Native audio generation does not guarantee intelligible dialogue, exact lip synchronization or cleared music rights."
    ],
    sourceIds: [
      "googleVeo",
      "googleFlow"
    ],
    related: [
      {
        "label": "Runway Gen-4 consistency analysis",
        "to": "/ai-news/runway-gen4-consistent-ai-video-production"
      },
      {
        "label": "AI news index",
        "to": "/ai-news"
      }
    ]
  },
  "/ai-news/fable-showrunner-ai-tv-simulated-characters": {
    ...common,
    heading: "Persistent characters require state, rules and editorial control",
    summary: "Showrunner is positioned as an entertainment system for generating and directing stories inside simulated worlds. That is different from asking a video model for one clip because characters and locations need memory across scenes. The editorial test is whether motives, relationships, geography and visual identity remain coherent after repeated user interventions. A simulated world can create more continuity than isolated prompts, but it can also accumulate contradictions that require human correction.",
    verifiedFacts: [
      "Showrunner’s official site presents the product around AI-generated entertainment and user-directed shows.",
      "Persistent storytelling requires state management in addition to image or video generation."
    ],
    evidenceLimits: [
      "A playable demonstration does not establish stable narrative coherence over long sessions.",
      "The public product description does not reveal every model, dataset, moderation rule or production-rights arrangement."
    ],
    sourceIds: [
      "showrunner"
    ],
    related: [
      {
        "label": "Google Veo and Flow filmmaking",
        "to": "/ai-news/google-veo-flow-ai-filmmaking-native-audio"
      },
      {
        "label": "Runway Gen-4 video consistency",
        "to": "/ai-news/runway-gen4-consistent-ai-video-production"
      }
    ]
  },
  "/ai-news/claude-fable-mythos-cybersecurity-release-gate": {
    ...common,
    heading: "Access changed after the June 2026 export-control interruption",
    summary: "Anthropic launched Fable 5 for broad use and Mythos 5 for limited Project Glasswing access, then suspended both models on 12 June 2026 after a US government export-control directive. Anthropic announced on 30 June that the controls had been lifted and restored Fable globally from 1 July, while Mythos access resumed for approved organizations. This timeline matters because release status, nationality restrictions and model capability were separate issues.",
    verifiedFacts: [
      "Anthropic documents Fable 5 as generally available and Mythos 5 as limited availability for vetted customers.",
      "The company’s redeployment notice records the suspension, lifted controls and different restoration paths for the two models."
    ],
    evidenceLimits: [
      "Limited access does not by itself quantify a model’s cyber risk.",
      "Developer benchmarks and system cards do not predict the outcome of every real security task or misuse attempt."
    ],
    sourceIds: [
      "anthropicFableMythos",
      "anthropicRedeploy"
    ],
    related: [
      {
        "label": "GPT-5.6 and Grok 4.5 comparison",
        "to": "/ai-news/gpt-56-grok-45-frontier-ai-comparison"
      },
      {
        "label": "AI news index",
        "to": "/ai-news"
      }
    ]
  },
  "/ai-news/gpt-56-grok-45-frontier-ai-comparison": {
    ...common,
    heading: "Both model families are now publicly documented",
    summary: "OpenAI moved GPT-5.6 from preview to general availability on 9 July 2026, with Sol, Terra and Luna as capability and price tiers. SpaceXAI launched Grok 4.5 on 16 July for Grok Build, Cursor and its API, publishing price and throughput claims. The comparison should therefore no longer describe Grok as a private Tesla or SpaceX beta. The remaining caution is methodological most benchmark figures come from the model developers and may use different harnesses.",
    verifiedFacts: [
      "OpenAI’s official launch page lists the GPT-5.6 family and general availability after the limited preview.",
      "SpaceXAI’s launch page lists Grok 4.5 for coding, agentic tasks and knowledge work, with public API pricing."
    ],
    evidenceLimits: [
      "Developer-reported benchmark charts are not a neutral head-to-head laboratory test.",
      "Price, tokens per second and benchmark scores do not establish lower defect rates on a team’s own workload."
    ],
    sourceIds: [
      "openaiGpt56",
      "spaceXaiGrok45"
    ],
    related: [
      {
        "label": "Detailed GPT-5.6 guide",
        "to": "/ai/gpt-5-6-grok-claude-comparison"
      },
      {
        "label": "Detailed Grok 4.5 guide",
        "to": "/ai/grok-4-5-openai-claude-comparison"
      }
    ]
  },
  "/robotics-news/home-robot-watering-plants-zen-future": {
    ...common,
    heading: "A useful home robot starts with a bounded job",
    summary: "Watering a plant looks simple, but a robot must identify the pot, estimate reach, control the container, avoid spilling, distinguish soil from surrounding surfaces and stop when the task leaves its safe envelope. A quiet demonstration can illustrate the interaction goal without proving an autonomous household product. The strongest near-term home use cases will define the object set, room layout, supervision method and recovery behavior before claiming general domestic intelligence.",
    verifiedFacts: [
      "Current home-humanoid product pages separate direct autonomy claims from remote supervision or expert-assistance modes.",
      "ROS 2 provides system components for sensing and control, but task reliability depends on the complete robot, environment and policy."
    ],
    evidenceLimits: [
      "One prepared plant-watering sequence does not establish navigation or manipulation in an unfamiliar home.",
      "The clip does not disclose spill rate, human intervention, water-volume sensing or recovery after a failed grasp."
    ],
    sourceIds: [
      "oneXNeo",
      "ros2"
    ],
    related: [
      {
        "label": "home and service robots",
        "to": "/robot-types/service-robots"
      },
      {
        "label": "robot sensors guide",
        "to": "/robot-sensors"
      }
    ]
  },
  "/robotics-news/pain-like-feedback-loop-humanoid-robots": {
    ...common,
    heading: "Protective feedback is an engineering loop, not a feeling",
    summary: "A robot can detect abnormal force, temperature, impact or joint load and reduce motion before hardware is damaged. Engineers sometimes compare this protective loop with pain because it changes behavior after harmful contact. The analogy should stop there. The measurable questions are sensor location, detection latency, threshold selection, false alarms, safe-state behavior and whether the controller can distinguish ordinary task contact from a damaging event.",
    verifiedFacts: [
      "Tactile and force sensing can provide contact signals for protective control.",
      "A controller can encode withdrawal, torque reduction or task cancellation without any claim about subjective experience."
    ],
    evidenceLimits: [
      "The available demonstration does not prove consciousness, suffering or a biological pain pathway.",
      "A threshold that protects one joint or surface may be too sensitive or too slow for another task."
    ],
    sourceIds: [
      "roboticSkinPaper",
      "shadowHand",
      "ros2"
    ],
    related: [
      {
        "label": "NRE-skin protective reflex analysis",
        "to": "/robotics-news/nre-skin-humanoid-protective-reflex"
      },
      {
        "label": "robot sensors guide",
        "to": "/robot-sensors"
      }
    ]
  },
  "/robotics-news/nre-skin-humanoid-protective-reflex": {
    ...common,
    heading: "The claim should be reduced to sensing, classification and response",
    summary: "The NRE-skin clip is best understood as a proposed protective surface and reflex loop. A useful technical description names the stimulus, sensor modality, sampling rate, response command and safe state. Without those details, the article should not infer that the robot feels pain. The defensible claim is narrower distributed contact data may help a robot localize harmful interaction and react before a motor, cable, cover or human collaborator is put at greater risk.",
    verifiedFacts: [
      "Robotic-skin research combines distributed sensing with controllers that respond to contact.",
      "Protective withdrawal can be implemented as a deterministic or learned control policy."
    ],
    evidenceLimits: [
      "The original source post alone did not supply a research protocol. The main article now links the NRE-Skin PNAS study; neither that research demonstration nor the clip establishes long-term product durability.",
      "A visible withdrawal motion does not reveal false-positive rate, impact tolerance or long-term reliability."
    ],
    sourceIds: [
      "roboticSkinPaper",
      "ros2"
    ],
    related: [
      {
        "label": "pain-like robot feedback loops",
        "to": "/robotics-news/pain-like-feedback-loop-humanoid-robots"
      },
      {
        "label": "robot sensors guide",
        "to": "/robot-sensors"
      }
    ]
  },
  "/robotics-news/robots-design-around-the-world-40-systems": {
    ...common,
    heading: "Robot form follows the task, workspace and economics",
    summary: "A gallery of forty systems is useful only when the bodies are connected to work. Fixed arms trade mobility for stiffness and repeatability. Delta robots minimize moving mass for fast sorting. Quadrupeds cross terrain. Humanoids target spaces and tools designed around people, while accepting more joints, balance control and cost. The revised context prevents a visual list from implying that all robots compete on the same performance scale.",
    verifiedFacts: [
      "The International Federation of Robotics distinguishes industrial configurations and application categories.",
      "Official product pages show that humanoid, quadruped and fixed-arm systems publish different payload, reach, sensing and operating assumptions."
    ],
    evidenceLimits: [
      "A design count is not a market-share or deployment count.",
      "Appearance alone does not establish autonomy, safety certification, production volume or task success."
    ],
    sourceIds: [
      "ifr",
      "unitree",
      "universalRobots"
    ],
    related: [
      {
        "label": "robot types index",
        "to": "/robot-types"
      },
      {
        "label": "robotics companies directory",
        "to": "/robotics-companies"
      }
    ]
  },
  "/robotics-news/unitree-humanoid-concert-glitch-human-reaction": {
    ...common,
    reviewed: "2026-07-27",
    heading: "A stage recovery is evidence about choreography, not factory uptime",
    summary: "Live performances expose timing, balance and human-robot coordination in front of an audience. Unitree lists several humanoid platforms and has used H1 robots in public performances, but a concert sequence remains a choreographed environment. When a robot pauses or deviates, the relevant questions are whether an operator intervened, whether the controller entered a safe state, how nearby performers were protected and whether the system resumed or was removed.",
    verifiedFacts: [
      "Unitree publicly lists H1, G1 and other humanoid platforms and documents performance events.",
      "A calm response does not establish that close contact with an unexpectedly moving robot is safe. The clip does not document a verified stopping or separation procedure."
    ],
    evidenceLimits: [
      "The clip alone cannot identify the failure source communication, localization, balance control, choreography or hardware.",
      "A successful stage recovery does not establish hours of unsupervised industrial operation."
    ],
    sourceIds: [
      "unitree"
    ],
    related: [
      {
        "label": "Unitree G1 product context",
        "to": "/robotics/unitree-wheeled-robot-dog-bionic-wheelchair"
      },
      {
        "label": "humanoid robot guide",
        "to": "/robot-types/humanoid-robots"
      }
    ]
  },
  "/robotics-news/t800-humanoid-demo-safety-question": {
    ...common,
    heading: "Safety depends on the control envelope around the T800",
    summary: "EngineAI’s official T800 page publishes a 173-centimetre humanoid, tactile sensing and high-torque joints. Those specifications help identify the platform, but safety near people depends on speed limits, force limits, emergency stops, fall behavior, separation monitoring and the exact demo mode. A kick or impact sequence can show structural control under prepared conditions while still leaving everyday human-robot interaction unmeasured.",
    verifiedFacts: [
      "EngineAI publishes the T800 as a full-size humanoid with tactile sensing and joint-level hardware specifications.",
      "High peak joint torque increases capability and makes the safety controller, test perimeter and failure response more important."
    ],
    evidenceLimits: [
      "A promotional demonstration does not disclose collision-force measurements or independent safety certification.",
      "Published payload and torque values do not reveal intervention rate, fall frequency or reliability over repeated shifts."
    ],
    sourceIds: [
      "engineAiT800"
    ],
    related: [
      {
        "label": "detailed EngineAI T800 profile",
        "to": "/robotics/engineai-t800-humanoid-robot"
      },
      {
        "label": "humanoid robot safety context",
        "to": "/robot-types/humanoid-robots"
      }
    ]
  },
  "/robotics-news/lingbot-2-embodied-intelligence-shared-environment": {
    ...common,
    heading: "Shared-space intelligence requires coordination and recovery",
    summary: "Multiple robots working around water, game pieces or household objects must do more than recognize a scene. They need a common world state, task ownership, collision avoidance, timing and a recovery rule when one action changes another robot’s plan. LingBot-World research focuses on embodied world modeling, while Robbyant’s public repositories provide implementation context. Neither source turns a teaser into proof of unrestricted multi-robot autonomy.",
    verifiedFacts: [
      "Embodied world models attempt to predict how actions change a physical scene.",
      "Open repositories and papers make architecture easier to inspect, but hardware execution still depends on embodiment-specific control."
    ],
    evidenceLimits: [
      "A short edited sequence does not disclose teleoperation, resets or the number of failed attempts.",
      "Success on chess, pouring or sorting does not automatically transfer to unfamiliar objects or crowded rooms."
    ],
    sourceIds: [
      "lingbotWorld2",
      "robbyantGithub"
    ],
    related: [
      {
        "label": "LingBot VA 2.0 control model",
        "to": "/robotics/lingbot-va-2-robot-control-foundation-model"
      },
      {
        "label": "robotics data collection",
        "to": "/robotics-data-collection"
      }
    ]
  },
  "/robotics/wandercraft-calvin-0-5-humanoid-robot": {
    ...common,
    heading: "Calvin 0.5 should be judged as an industrial prototype",
    summary: "Wandercraft’s background in self-balancing exoskeletons gives Calvin a relevant locomotion base, while the industrial program targets handling tasks rather than a general household assistant. The 0.5 label is important it signals an iteration whose value lies in integration, task trials and learning with partners. Readers should separate the existence of a Renault Group relationship from evidence that the robot is already working continuously on production lines.",
    verifiedFacts: [
      "Wandercraft publicly develops mobility robotics and the Calvin humanoid program.",
      "Industrial validation requires a named task, workcell, cycle time, payload and human-intervention record."
    ],
    evidenceLimits: [
      "A partnership or prototype unveiling does not establish deployment volume.",
      "The available material does not provide a comparable reliability or throughput figure against a conventional automation cell."
    ],
    sourceIds: [
      "wandercraft"
    ],
    related: [
      {
        "label": "French humanoid projects",
        "to": "/robotics/france-humanoid-robots-worth-watching"
      },
      {
        "label": "humanoid manufacturing requirements",
        "to": "/robotics/humanoid-robot-mass-production-requirements"
      }
    ]
  },
  "/robotics/france-humanoid-robots-worth-watching": {
    ...common,
    heading: "France’s projects solve different robotics problems",
    summary: "Wandercraft, Pollen Robotics, Enchanted Tools and the NAO lineage should not be ranked as versions of the same product. Their platforms address industrial manipulation, open research, service interaction and education with different sizes, actuators and commercial models. A useful country guide identifies the developer, current platform, intended task and source date, then leaves undisclosed payload, autonomy and production figures blank.",
    verifiedFacts: [
      "Wandercraft, Pollen Robotics and Enchanted Tools maintain official product or company pages for distinct robot platforms.",
      "The published NAO paper documents an earlier French humanoid designed around performance and affordability for research and education."
    ],
    evidenceLimits: [
      "A national list is not a deployment ranking or a claim of domestic component supply.",
      "Prototype visibility and social reach do not establish current production capacity."
    ],
    sourceIds: [
      "wandercraft",
      "pollen",
      "enchanted",
      "naoPaper"
    ],
    related: [
      {
        "label": "Wandercraft Calvin 0.5",
        "to": "/robotics/wandercraft-calvin-0-5-humanoid-robot"
      },
      {
        "label": "French humanoid directory",
        "to": "/humanoid-robots/france"
      }
    ]
  },
  "/robotics/engineai-t800-humanoid-robot": {
    ...common,
    heading: "Manufacturer T800 specifications need task-level testing",
    summary: "EngineAI’s product page identifies the T800 as a 173-centimetre humanoid and lists tactile sensing, a 5-kilogram payload figure and maximum joint torque up to 450 newton-metres. These are hardware specifications, not a universal performance score. For manipulation or mobility, the next evidence should include the exact payload location, speed, run duration, floor condition, fall recovery and whether a human operator provided commands.",
    verifiedFacts: [
      "The official page provides platform dimensions and selected joint, sensing and battery details.",
      "A full-size humanoid combines capability with a larger fall envelope and greater stored mechanical energy than a tabletop robot."
    ],
    evidenceLimits: [
      "Maximum torque is not sustained torque and does not establish safe contact force.",
      "The available product page does not provide an independent duty-cycle, intervention-rate or workplace-safety study."
    ],
    sourceIds: [
      "engineAiT800"
    ],
    related: [
      {
        "label": "T800 demo safety analysis",
        "to": "/robotics-news/t800-humanoid-demo-safety-question"
      },
      {
        "label": "humanoid hardware cost drivers",
        "to": "/robotics/humanoid-robot-hardware-cost-drivers"
      }
    ]
  },
  "/robotics/bristol-soft-robot-liquid-metal-droplet": {
    ...common,
    heading: "The liquid-metal element should be evaluated inside the full actuator",
    summary: "The Bristol research clip describes a liquid-metal droplet used to improve a soft robotic pumping mechanism. The engineering value depends on how the droplet changes pressure, flow, efficiency or response compared with a baseline design. Soft actuators can deform safely around objects, but they also introduce material fatigue, sealing, hysteresis and sensing challenges. A university demonstration is evidence of a mechanism, not yet evidence of a manufacturable product.",
    verifiedFacts: [
      "The University of Bristol conducts soft-robotics research across compliant materials and actuation.",
      "A liquid metal can provide electrical or fluidic behavior while the surrounding structure determines durability and usable force."
    ],
    evidenceLimits: [
      "The source material does not establish production cost, cycle life, leakage rate or field reliability.",
      "Performance in one pump geometry cannot be generalized to every artificial muscle or soft robot."
    ],
    sourceIds: [
      "bristol",
      "softToolkit"
    ],
    related: [
      {
        "label": "soft robotics guide",
        "to": "/robot-types/soft-robotics"
      },
      {
        "label": "robot sensors and tactile systems",
        "to": "/robot-sensors"
      }
    ]
  },
  "/robotics/yaskawa-high-speed-delta-robot-pick-and-place": {
    ...common,
    heading: "Delta-robot speed only matters with accuracy and product handling",
    summary: "Yaskawa markets delta robots for packaging and high-speed pick-and-place, where low moving mass supports rapid cycles over a defined work envelope. A complete comparison must include payload, reach, repeatability, vision latency, conveyor tracking, end-effector mass and the product’s tolerance to acceleration. The fastest empty-arm motion is not the same as sustained throughput with inspection, gripping and reject handling.",
    verifiedFacts: [
      "Yaskawa’s packaging pages place high-speed robots inside complete automation cells with vision and handling equipment.",
      "Delta kinematics favor fast overhead motion but have a different workspace and payload profile from six-axis arms."
    ],
    evidenceLimits: [
      "A cycle-time figure cannot be transferred to a different product, gripper or conveyor layout.",
      "Promotional footage does not disclose changeover time, mis-pick rate or maintenance interval."
    ],
    sourceIds: [
      "yaskawaPackaging",
      "ifr"
    ],
    related: [
      {
        "label": "industrial robot types",
        "to": "/robot-types/industrial-robots"
      },
      {
        "label": "robotic grippers and end effectors",
        "to": "/robot-types/robotic-grippers-and-end-effectors"
      }
    ]
  },
  "/robotics/ubtech-ultra-bionic-humanoid-robot": {
    ...common,
    heading: "A lifelike appearance should not be confused with general autonomy",
    summary: "UBTECH develops humanoid and service robots, and a highly expressive or human-like shell can improve communication in demonstrations. The technical evaluation still needs to identify which motions are pre-programmed, teleoperated or generated online; what sensors track nearby people; and how the robot behaves after lost balance or communication. Surface realism is an interface feature, not evidence of dexterity, reasoning or reliable work.",
    verifiedFacts: [
      "UBTECH maintains official pages for humanoid and service-robot products.",
      "Human-like facial or body motion can be controlled separately from navigation and manipulation autonomy."
    ],
    evidenceLimits: [
      "The clip does not provide an autonomy level, continuous run time or intervention rate.",
      "A lifelike exterior does not establish safe force control, robust hands or conversational understanding."
    ],
    sourceIds: [
      "ubtech"
    ],
    related: [
      {
        "label": "UBTECH 2026 launch event",
        "to": "/robotics/ubtech-2026-global-launch-event"
      },
      {
        "label": "Chinese humanoid robots",
        "to": "/humanoid-robots/china"
      }
    ]
  },
  "/robotics/humanoid-robots-developed-in-spain": {
    ...common,
    heading: "Spain’s humanoid projects span research and commercial service robotics",
    summary: "PAL Robotics and Universidad Carlos III de Madrid provide documented examples of Spanish humanoid work, but their systems should be described by project and date rather than grouped as one national capability. TALOS, REEM-C, TEO and KANGAROO address different research or service goals. The page now anchors the list to official organizations and papers while avoiding unsupported claims about current sales, autonomy or production volume.",
    verifiedFacts: [
      "PAL Robotics publishes commercial and research robot platforms from Spain.",
      "Academic papers document KANGAROO lower-body modeling and TEO-related human-robot interaction research."
    ],
    evidenceLimits: [
      "A research paper may describe an earlier configuration that differs from current hardware.",
      "Country of development does not reveal where every motor, reducer, sensor or controller is manufactured."
    ],
    sourceIds: [
      "palRobotics",
      "kangarooPaper",
      "teoPaper"
    ],
    related: [
      {
        "label": "robotics companies directory",
        "to": "/robotics-companies"
      },
      {
        "label": "European humanoid projects",
        "to": "/robotics/france-humanoid-robots-worth-watching"
      }
    ]
  },
  "/robotics/unitree-wheeled-robot-dog-bionic-wheelchair": {
    ...common,
    heading: "An experimental mobility platform is not a certified wheelchair",
    summary: "A modified Unitree quadruped can illustrate how legged mobility, wheels and a seat might cross terrain that challenges a conventional chair. Medical mobility equipment, however, is evaluated around braking, occupant restraint, stability, controls, battery safety, transfer, failure modes and applicable regulation. The page now distinguishes a maker experiment from a device cleared or marketed for patient use.",
    verifiedFacts: [
      "Unitree sells quadruped robot platforms that third parties can modify for research.",
      "The FDA treats many powered mobility products as medical devices under defined regulatory requirements in the United States."
    ],
    evidenceLimits: [
      "The modification is not presented as an FDA-cleared wheelchair or a clinical product.",
      "A flat-floor ride does not establish curb handling, emergency stopping, rollover resistance or safe occupant transfer."
    ],
    sourceIds: [
      "unitree",
      "fdaDevices"
    ],
    related: [
      {
        "label": "Unitree robot platforms",
        "to": "/robot-types/robot-dogs-quadrupeds"
      },
      {
        "label": "service and assistive robots",
        "to": "/robot-types/service-robots"
      }
    ]
  },
  "/robotics/humanoid-robot-companies-by-continent": {
    ...common,
    heading: "A company map needs a transparent inclusion rule",
    summary: "Counts by continent can change quickly because companies rename platforms, move headquarters, pause programs or announce robots before publishing hardware. This page should count a developer only when an official site or primary document identifies an active humanoid project. Headquarters, research location, manufacturing site and component origin are separate fields. The result is a directory snapshot, not a ranking of technical leadership.",
    verifiedFacts: [
      "Official company and product pages are stronger inclusion evidence than reposted videos or investor summaries.",
      "A continent count measures listed organizations, not shipments, revenue, robot capability or domestic supply-chain depth."
    ],
    evidenceLimits: [
      "Private teams and undisclosed projects will be missing.",
      "The count can become stale and should display a review date whenever companies are added or removed."
    ],
    sourceIds: [
      "apptronikApollo",
      "figure",
      "unitree",
      "wandercraft"
    ],
    related: [
      {
        "label": "robotics companies directory",
        "to": "/robotics-companies"
      },
      {
        "label": "global robotics country guide",
        "to": "/robotics-news/22-countries-global-robotics"
      }
    ]
  },
  "/robotics/humanoid-robots-teleoperated-laparoscopic-surgery": {
    ...common,
    heading: "The published work demonstrates teleoperation, not independent surgery",
    summary: "The cited research explores humanoid platforms as teleoperated interfaces for laparoscopic tasks. In teleoperation, a human surgeon remains the decision-maker and the robot maps commands to instruments. The meaningful measurements are latency, motion scaling, tremor filtering, workspace constraints, tissue interaction, emergency stop and surgeon workload. A successful experimental procedure does not authorize clinical use or show that the robot can diagnose, plan and operate independently.",
    verifiedFacts: [
      "The linked studies explicitly frame the systems around teleoperated laparoscopic work.",
      "Surgical robotics requires controlled instruments, trained operators and validation that extends beyond general-purpose humanoid movement."
    ],
    evidenceLimits: [
      "A feasibility study is not regulatory clearance or evidence of routine hospital deployment.",
      "Results from a specific animal, bench or simulated task cannot be generalized to all procedures or patients."
    ],
    sourceIds: [
      "surgeryStudy",
      "lapSurgie",
      "intuitive"
    ],
    related: [
      {
        "label": "medical and surgical robots",
        "to": "/robot-types/medical-surgical-robots"
      },
      {
        "label": "humanoid robot hands",
        "to": "/robot-types/humanoid-robot-hands"
      }
    ]
  },
  "/robotics/ubtech-2026-global-launch-event": {
    ...common,
    heading: "Launch announcements need separate product and deployment records",
    summary: "UBTECH’s 2026 event combined humanoid, companion and service-robot announcements. A launch presentation can establish that a company has named a platform and disclosed intended features; it cannot establish shipment volume, customer acceptance or continuous autonomy. Each robot should be followed through its own official specification, delivery status and named deployment evidence rather than treated as one verified fleet.",
    verifiedFacts: [
      "UBTECH maintains official product information for multiple robot categories.",
      "Public reporting on the 2026 companion-robot launch provides independent event context, while technical specifications still come primarily from the developer."
    ],
    evidenceLimits: [
      "Stage demonstrations may use prepared maps, scripts or remote operators.",
      "An announced launch date does not prove that every configuration is commercially available in every market."
    ],
    sourceIds: [
      "ubtech"
    ],
    related: [
      {
        "label": "UBTECH ultra-bionic humanoid",
        "to": "/robotics/ubtech-ultra-bionic-humanoid-robot"
      },
      {
        "label": "humanoid mass production requirements",
        "to": "/robotics/humanoid-robot-mass-production-requirements"
      }
    ]
  },
  "/robotics/agibot-humanoid-robot-hardware-teardown": {
    ...common,
    heading: "A teardown reveals architecture, not component endurance",
    summary: "The teardown identifies EtherCAT communication, distributed control boards, power electronics and motor-control sections inside an AgiBot humanoid. That is useful because it shows how sensing and actuation are divided across the body. The images still cannot establish firmware quality, thermal margins, ingress protection, cable life or the exact supplier and rating of every component. Internal architecture should be connected to serviceability and failure isolation, not treated as proof of performance.",
    verifiedFacts: [
      "AgiBot publicly develops humanoid platforms and related embodied-intelligence systems.",
      "EtherCAT is commonly used for deterministic industrial communication between controllers and distributed devices."
    ],
    evidenceLimits: [
      "Board labels and photographs do not reveal software timing, safety certification or sustained current limits.",
      "A single opened unit may not represent every production revision or configuration."
    ],
    sourceIds: [
      "agibot",
      "ros2"
    ],
    related: [
      {
        "label": "robot components guide",
        "to": "/robot-components"
      },
      {
        "label": "robotics software stack",
        "to": "/robotics-software"
      }
    ]
  },
  "/robotics/rice-nasa-imetro-space-robotics-simulator": {
    ...common,
    heading: "Simulation value depends on model fidelity and reproducibility",
    summary: "The iMETRO work connects Rice University and NASA-oriented research on robots operating inside spacecraft. A dynamic simulator can test contact, locomotion and manipulation without risking flight hardware, while exposing assumptions that can be repeated by other researchers. The critical details are the robot model, inertia, contact parameters, environmental geometry, controller, validation data and whether the code and scenarios are actually released under an open license.",
    verifiedFacts: [
      "NASA Johnson Space Center conducts human-spaceflight and robotics work for spacecraft environments.",
      "Open simulation can make experiments easier to reproduce, but results still require comparison with physical hardware."
    ],
    evidenceLimits: [
      "A simulator cannot reproduce every cable, material, sensor-noise and microgravity interaction.",
      "The article should not infer NASA deployment or mission selection from research collaboration alone."
    ],
    sourceIds: [
      "riceNews",
      "nasaJohnson",
      "mujoco"
    ],
    related: [
      {
        "label": "space robotics guide",
        "to": "/robot-types/space-robotics"
      },
      {
        "label": "robotics simulation software",
        "to": "/robotics-software"
      }
    ]
  },
  "/robotics/humanoid-robot-mass-production-requirements": {
    ...common,
    heading: "Mass production begins with repeatability and traceability",
    summary: "A factory can assemble many humanoids only after drawings, tolerances, suppliers, calibration, firmware, test fixtures and repair procedures are stable enough to repeat. ISO 9001 provides a quality-management framework, while NIST manufacturing resources emphasize measurement and process control. The commercial test is not a video of an assembly line. It is yield, rework, field failure, spare-parts availability, service time and cost per accepted unit.",
    verifiedFacts: [
      "Quality management requires documented processes, corrective action and traceability rather than a final visual inspection alone.",
      "Humanoids combine many actuators, reducers, sensors and cables, so small component variation can accumulate into calibration and reliability problems."
    ],
    evidenceLimits: [
      "A claimed production target is not the same as shipped and accepted units.",
      "Factory floor area or worker count does not disclose yield, warranty cost or supplier capacity."
    ],
    sourceIds: [
      "iso9001",
      "nistManufacturing"
    ],
    related: [
      {
        "label": "humanoid hardware cost drivers",
        "to": "/robotics/humanoid-robot-hardware-cost-drivers"
      },
      {
        "label": "robot components guide",
        "to": "/robot-components"
      }
    ]
  },
  "/robotics/pepper-softbank-social-humanoid-robot": {
    ...common,
    heading: "Pepper’s legacy is interaction design under constrained capability",
    summary: "Pepper became recognizable because it combined speech, a screen, head and arm gestures and a human-scale social presence. Its value was strongest in structured reception, education and research settings where scripted interaction and remote content management were acceptable. The platform also demonstrated the limits of social robots conversation quality, noise, maintenance and user expectations can matter more than a humanoid silhouette.",
    verifiedFacts: [
      "Aldebaran continues to document Pepper and NAO as social and educational robot platforms.",
      "Social engagement can be measured through task completion, user response and operator effort without claiming human-level understanding."
    ],
    evidenceLimits: [
      "A successful greeting or scripted dialogue does not establish open-ended reasoning.",
      "Historical visibility does not reveal the current installed base, support status or economics of each deployment."
    ],
    sourceIds: [
      "aldebaran",
      "naoPaper"
    ],
    related: [
      {
        "label": "service robots guide",
        "to": "/robot-types/service-robots"
      },
      {
        "label": "French humanoid projects",
        "to": "/humanoid-robots/france"
      }
    ]
  },
  "/robotics/dji-drone-range-camera-flight-time-comparison": {
    ...common,
    heading: "Compare drones under the same regulatory and flight assumptions",
    summary: "DJI’s Neo, Mini 4 Pro, Air 3S, Avata 2 and Mavic 4 Pro serve different pilots, camera goals and risk profiles. Official maximum flight time and transmission distance are measured under specified conditions and should not be read as guaranteed real-world range. A useful buyer comparison adds takeoff weight, sensor format, obstacle sensing, wind tolerance, storage, controller requirements and local flight rules before choosing a model.",
    verifiedFacts: [
      "DJI publishes separate specification pages for each compared aircraft.",
      "Battery endurance changes with wind, speed, temperature, payload, altitude and battery condition."
    ],
    evidenceLimits: [
      "Maximum transmission distance is not permission to fly beyond visual-line-of-sight rules.",
      "Camera resolution alone does not determine dynamic range, low-light quality, stabilization or editing flexibility."
    ],
    sourceIds: [
      "djiNeo",
      "djiMini4",
      "djiAir3s",
      "djiAvata2",
      "djiMavic4"
    ],
    related: [
      {
        "label": "robot perception on difficult surfaces",
        "to": "/robotics/robot-perception-transparent-reflective-objects"
      },
      {
        "label": "flying excavator engineering analysis",
        "to": "/robotics/flying-excavator-concept-engineering-analysis"
      }
    ]
  },
  "/robotics/flying-excavator-concept-engineering-analysis": {
    ...common,
    heading: "The concept is dominated by mass, downwash and failure energy",
    summary: "An excavator arm needs a heavy base because digging creates large reaction forces. Suspending that system under rotors removes the ground reaction and adds lift power, downwash, pendulum motion and a severe failure envelope above workers. A defensible concept study must balance total mass, rotor disk area, hover power, tool force, cable dynamics, flight control, exclusion zones and the legal operating category before discussing construction productivity.",
    verifiedFacts: [
      "FAA unmanned-aircraft rules apply to real flight operations in the United States, with additional requirements depending on aircraft and mission.",
      "NIOSH construction guidance treats mobile equipment and struck-by hazards as central worksite safety concerns."
    ],
    evidenceLimits: [
      "A render does not establish a flyable mass budget, control system or certified operating plan.",
      "Even a hovering prototype would not prove safe digging near workers, structures, dust or suspended loads."
    ],
    sourceIds: [
      "faaUas",
      "nioshConstruction"
    ],
    related: [
      {
        "label": "drone specifications comparison",
        "to": "/robotics/dji-drone-range-camera-flight-time-comparison"
      },
      {
        "label": "construction and inspection robots",
        "to": "/robot-types/inspection-maintenance-robots"
      }
    ]
  },

  "/ai/best-ai-math-solvers-2026": {
    ...common,
    reviewed: "2026-09-30",
    heading: "A robotics student should test the solver on engineering math, not only textbook arithmetic",
    summary: "For robotics work, a useful math assistant must keep units, coordinate frames, matrix dimensions and assumptions visible. A correct final number is not enough when the same calculation feeds inverse kinematics, calibration, trajectory timing or controller gains. The following discussion suggests robotics-oriented checks; it does not supply a completed robotics test set or measured tool comparison.",
    verifiedFacts: [
      "Robot kinematics commonly uses vectors, rotation matrices, homogeneous transforms and Jacobians rather than isolated arithmetic exercises.",
      "Simulation tools such as MuJoCo and Isaac Sim still require the user to define physical parameters, frames and constraints; a solver cannot infer missing engineering assumptions safely.",
      "A useful verification habit is to check dimensions, units, limiting cases and one independent numerical calculation before carrying an answer into robot code."
    ],
    evidenceLimits: [
      "A fluent step-by-step explanation does not prove that a coordinate-frame convention or sign choice is correct.",
      "Symbolic correctness does not establish that a controller will remain stable on real hardware."
    ],
    sourceIds: ["mujoco", "isaacSim"],
    related: [
      { label: "robotics software stack", to: "/robotics-software" },
      { label: "robotics research topics", to: "/robotics-topics" }
    ]
  },
  "/ai/best-ai-resume-builders-2026": {
    ...common,
    reviewed: "2026-09-30",
    heading: "For robotics roles, the resume should expose the hardware, software and measured result",
    summary: "Generic resume generators tend to reward polished phrasing. Robotics hiring evidence is more concrete: robot platform, sensors, control stack, simulation environment, programming language, task, test conditions and measured result. This section gives readers a way to audit an AI-generated resume before sending it to a robotics lab or automation company.",
    verifiedFacts: [
      "ROS 2, simulation environments and robot hardware each represent different engineering skills and should be named separately when they were actually used.",
      "Project claims are easier to evaluate when they include the robot, task, dataset or environment and a measured outcome such as success rate, cycle time or error.",
      "A portfolio link can support a resume claim when it shows code, experiment setup, video or documentation that matches the stated work."
    ],
    evidenceLimits: [
      "An AI-written bullet can overstate ownership when several people contributed to the project.",
      "Keyword matching cannot substitute for evidence that the candidate built, tested or maintained the system described."
    ],
    sourceIds: ["ros2", "isaacSim", "icra2026"],
    related: [
      { label: "Physical AI", to: "/physical-ai" },
      { label: "robotics companies", to: "/robotics-companies" }
    ]
  },
  "/ai/best-ai-video-generators-2026": {
    ...common,
    reviewed: "2026-09-30",
    heading: "Robot footage needs a different evaluation from cinematic AI video",
    summary: "For robotics media, visual quality is only one test. Generated footage can change joint count, gripper geometry, contact timing, cable routing or object position between frames. Readers using AI video around robotics should separate illustration from evidence and label generated sequences so they are not mistaken for a real robot test.",
    verifiedFacts: [
      "Runway and Google Flow provide generation workflows based on prompts and visual references.",
      "Reference-based generation can improve continuity, but it does not verify mechanical geometry or physical feasibility.",
      "Real robot performance claims should remain tied to original footage, experiment records or primary technical sources."
    ],
    evidenceLimits: [
      "A generated clip can depict a motion that the named robot has never performed.",
      "Frame-to-frame visual continuity does not prove correct contact physics, torque limits or balance."
    ],
    sourceIds: ["runwayGen4", "googleFlow"],
    related: [
      { label: "robotics news", to: "/robotics-news" },
      { label: "Physical AI", to: "/physical-ai" }
    ]
  },
  "/ai/best-ai-tools-for-students-2026": {
    ...common,
    reviewed: "2026-09-30",
    heading: "A robotics study workflow should end with a reproducible experiment",
    summary: "Students learning robotics can use AI tools for explanations, code review and study plans, but the final check should happen in code, simulation or hardware. This section maps common study tasks to evidence a learner can reproduce: a ROS 2 node, a simulation scene, a kinematics calculation, a controller plot or a short experiment log.",
    verifiedFacts: [
      "ROS 2 documentation provides reproducible tutorials for nodes, topics, services and packages.",
      "MuJoCo and Isaac Sim let students test robot models under explicit simulation assumptions before moving to hardware.",
      "Keeping the prompt, code version, parameters and observed result makes an AI-assisted exercise easier to audit and repeat."
    ],
    evidenceLimits: [
      "Generated code may run while using the wrong frame, units, timing assumptions or API version.",
      "Simulation success alone does not establish performance on a physical robot."
    ],
    sourceIds: ["ros2", "mujoco", "isaacSim"],
    related: [
      { label: "robot sensors guide", to: "/robot-sensors" },
      { label: "robotics topics", to: "/robotics-topics" }
    ]
  },
  "/humanoid-robots/unitree-h1": {
    ...common,
    reviewed: "2026-09-30",
    heading: "Use the H1 specification sheet as a starting point, then separate platform limits from demonstration claims",
    summary: "The H1 page is most useful when readers can distinguish published hardware specifications from motions shown in selected videos. For a lab or buyer, the practical checklist is height and mass, joint configuration, actuator limits, onboard compute, sensing, battery operation, development interfaces, payload assumptions and the exact control mode used in each demonstration.",
    verifiedFacts: [
      "Unitree publishes H1 as a full-size humanoid platform and provides product specifications on its official site.",
      "A locomotion or manipulation clip does not by itself reveal teleoperation, policy inputs, reset conditions or the number of failed trials.",
      "Comparisons should use the same task and measurement method before treating speed, balance or manipulation quality as a platform advantage."
    ],
    evidenceLimits: [
      "Published peak values do not describe continuous operation under every thermal, battery or payload condition.",
      "A research platform specification does not establish factory uptime, service coverage or a production acceptance rate."
    ],
    sourceIds: ["unitree", "mujoco"],
    related: [
      { label: "humanoid robots directory", to: "/humanoid-robots" },
      { label: "Physical AI", to: "/physical-ai" }
    ]
  },
  "/robotics-companies/north-america": {
    ...common,
    reviewed: "2026-09-30",
    heading: "A company directory is more useful when it separates robot makers, integrators and component suppliers",
    summary: "North American robotics activity spans humanoids, industrial arms, mobile robots, inspection systems, surgical platforms, agriculture and software. The directory should help a reader identify what each company actually sells or tests, where the robot is used and whether the evidence is a product page, pilot, research project or deployed commercial system.",
    verifiedFacts: [
      "Industrial robot manufacturers, collaborative-robot vendors and general-purpose humanoid companies serve different deployment models.",
      "A named customer pilot is stronger deployment evidence than a company description alone, but a pilot still does not establish fleet-scale reliability.",
      "Official product pages are useful for specifications; independent deployment evidence is needed for uptime, intervention rate and operating cost."
    ],
    evidenceLimits: [
      "Company count is not market share.",
      "Funding, valuation or media visibility does not measure robot reliability or shipped fleet size."
    ],
    sourceIds: ["figure", "apptronikApollo", "universalRobots", "gecko"],
    related: [
      { label: "robotics companies directory", to: "/robotics-companies" },
      { label: "humanoid robots", to: "/humanoid-robots" }
    ]
  },
  "/zh-cn/humanoid-robots/ubtech-walker-s": {
    ...common,
    reviewed: "2026-09-30",
    heading: "把 Walker S 的官方参数、工厂试点和量产能力分开看",
    summary: "这类页面最有价值的做法，是把机器人本体参数、公开演示、客户试点和实际部署证据分成不同层级。读者在比较 Walker S 时，应记录任务类型、工作站环境、人工接管、连续运行时间、节拍和失败恢复，而不是只看一段演示视频。",
    verifiedFacts: [
      "UBTECH 的官方资料可用于核对 Walker 系列的产品定位和公开项目。",
      "工厂试点可以说明机器人进入了真实工作环境，但不能单独证明长期无人值守运行。",
      "与其他人形机器人比较时，应使用相同任务、环境和统计口径。"
    ],
    evidenceLimits: [
      "公开视频通常不会完整展示失败次数、人工重置和维护时间。",
      "单个客户试点不能直接外推到所有工厂或所有工位。"
    ],
    sourceIds: ["ubtech", "ifr"],
    related: [
      { label: "人形机器人目录", to: "/zh-cn/humanoid-robots" },
      { label: "机器人公司", to: "/zh-cn/robotics-companies" }
    ]
  },
  "/zh-cn/robotics-events": {
    ...common,
    reviewed: "2026-09-30",
    heading: "活动日历加入研究、产业和比赛三类证据",
    summary: "机器人活动不应只是一串日期。对读者更有用的是说明每个活动适合看什么：研究会议看论文和实验方法，产业展会看产品与集成商，机器人比赛看在统一规则下的任务表现。活动页面还应给出官方链接、城市、日期、报名状态和资料更新时间。",
    verifiedFacts: [
      "IEEE ICRA 属于机器人研究会议，论文与研讨会是核心内容。",
      "Automate 主要面向工业自动化和商业机器人生态。",
      "RoboCup 使用竞赛任务组织机器人研究与团队比较。"
    ],
    evidenceLimits: [
      "参展并不代表产品已经大规模部署。",
      "比赛成绩不能直接换算为工厂可靠性或商业市场份额。"
    ],
    sourceIds: ["icra2026", "automate", "robocup"],
    related: [
      { label: "机器人新闻", to: "/zh-cn/robotics-news" },
      { label: "机器人公司", to: "/zh-cn/robotics-companies" }
    ]
  },
  "/zh-cn/robotics-companies/country/japan": {
    ...common,
    reviewed: "2026-09-30",
    heading: "日本机器人公司目录按产品和应用场景区分",
    summary: "日本机器人产业同时包含工业机械臂、协作机器人、服务机器人和研究平台。目录的价值来自可核对的公司产品、应用行业和官方来源，而不是把所有公司放在同一个‘领先’标签下。",
    verifiedFacts: [
      "FANUC 和 Yaskawa 等公司长期提供工业机器人产品与自动化方案。",
      "工业机器人安装量与人形机器人研发属于不同统计口径，不能直接合并排名。",
      "公司目录应把制造商、集成商、软件公司和研究机构分开标注。"
    ],
    evidenceLimits: [
      "公司数量不能代表国家的机器人市场份额。",
      "官网产品列表不能替代真实部署数量、故障率和维护成本数据。"
    ],
    sourceIds: ["fanuc", "ifr", "yaskawaPackaging"],
    related: [
      { label: "全球机器人公司", to: "/zh-cn/robotics-companies" },
      { label: "机器人活动", to: "/zh-cn/robotics-events" }
    ]
  },
  "/zh-cn/ai/google-flow-ai-image-to-video-guide": {
    ...common,
    reviewed: "2026-09-30",
    heading: "机器人内容使用 AI 视频时要明确区分生成画面和真实测试",
    summary: "Google Flow 可以用于分镜、概念视频和视觉说明，但生成的机器人运动不能作为产品能力证据。机器人媒体内容应把真实拍摄、仿真画面和生成画面清楚标注，尤其是在展示抓取、行走、平衡和人机协作时。",
    verifiedFacts: [
      "Google Flow 提供基于文本和视觉参考的生成式视频工作流。",
      "视觉参考可以帮助保持主体外观，但不会验证关节结构、负载或接触物理。",
      "机器人性能结论应回到原始实验、官方技术资料或可复现测试。"
    ],
    evidenceLimits: [
      "生成视频可能出现现实机器人无法执行的动作。",
      "画面连续性不能证明控制稳定性或安全性。"
    ],
    sourceIds: ["googleFlow", "googleVeo"],
    related: [
      { label: "机器人新闻", to: "/zh-cn/robotics-news" },
      { label: "Physical AI", to: "/zh-cn/physical-ai" }
    ]
  },
  "/zh-cn/ai/google-ai-mode-search-traffic": {
    ...common,
    reviewed: "2026-09-30",
    heading: "机器人网站在 AI 搜索里需要可引用的数据和原始证据",
    summary: "对机器人媒体来说，最难被搜索摘要替代的内容通常是原始测试、参数表、部署记录、公司目录、活动数据库、实验视频和清楚的来源链。页面应该让读者看到数据从哪里来、何时更新、适用条件是什么。",
    verifiedFacts: [
      "机器人参数应尽量链接到制造商、论文或标准机构的原始来源。",
      "同一指标只有在任务、环境和测量方式一致时才适合直接比较。",
      "页面内的更新时间、来源和限制说明可以帮助读者判断数据是否仍然适用。"
    ],
    evidenceLimits: [
      "搜索可见度不能只由增加字数解决。",
      "重复整理公开资料而没有新的结构、验证或数据，仍可能缺少独立价值。"
    ],
    sourceIds: ["ifr", "icra2026", "ros2"],
    related: [
      { label: "机器人研究", to: "/zh-cn/robotics-news" },
      { label: "人形机器人", to: "/zh-cn/humanoid-robots" }
    ]
  },
  "/ja": {
    ...common,
    reviewed: "2026-09-30",
    heading: "ロボット情報は仕様、実験、導入実績を分けて確認する",
    summary: "TechniaHQRobot の日本語ページでは、人型ロボット、Physical AI、産業ロボットを同じ基準で評価しません。仕様表はメーカー資料、研究結果は論文、導入は現場条件と運用データに分けて確認すると、短いデモ動画だけでは見えない差が分かります。",
    verifiedFacts: [
      "産業ロボットの統計と人型ロボットの研究デモは異なる指標です。",
      "ROS 2 やシミュレータの結果は、実機での再現条件と分けて記録する必要があります。",
      "導入事例ではタスク、稼働時間、人の介入、失敗復帰を確認すると比較しやすくなります。"
    ],
    evidenceLimits: [
      "メーカー動画だけでは連続稼働率や失敗回数は分かりません。",
      "企業数や資金調達額だけでロボット性能は評価できません。"
    ],
    sourceIds: ["ifr", "ros2", "icra2026"],
    related: [
      { label: "ロボティクス", to: "/ja/robotics" },
      { label: "人型ロボット", to: "/ja/humanoid-robots" }
    ]
  },
  "/ja/robotics": {
    ...common,
    reviewed: "2026-09-30",
    heading: "ロボットの主張を再現条件まで確認するチェックリスト",
    summary: "ロボット記事では、機体、センサー、制御方式、環境、オペレーター介入、試行回数、失敗復帰を確認します。同じ『自律』という言葉でも、遠隔操作、上位命令だけの自律、完全なタスク実行では意味が異なります。",
    verifiedFacts: [
      "ROS 2 はロボットソフトウェアの通信とツールを提供しますが、個別ロボットの安全性や性能を保証しません。",
      "Isaac Sim と MuJoCo は条件を定義したシミュレーションに使えますが、実機検証は別に必要です。",
      "比較では同じタスク、環境、測定方法を使う必要があります。"
    ],
    evidenceLimits: [
      "短い成功動画は成功率を示しません。",
      "シミュレーション結果だけでは実機の摩擦、遅延、センサー誤差を完全には表せません。"
    ],
    sourceIds: ["ros2", "isaacSim", "mujoco"],
    related: [
      { label: "Physical AI", to: "/ja/physical-ai" },
      { label: "人型ロボット", to: "/ja/humanoid-robots" }
    ]
  },
  "/ja/ai/best-ai-image-generators-2026": {
    ...common,
    reviewed: "2026-09-30",
    heading: "ロボット画像では生成素材と実機写真を混同しない",
    summary: "AI 画像生成は記事の概念図やサムネイルに使えますが、ロボットの仕様や実機能力を示す証拠にはなりません。関節数、ハンド形状、センサー配置、ケーブル、ロゴが生成ごとに変わることがあるため、製品比較では公式写真や一次資料と分けて扱います。",
    verifiedFacts: [
      "生成画像は視覚説明に使えますが、実機の寸法や構造を測定したデータではありません。",
      "ロボット製品ページの仕様確認にはメーカー資料や研究論文が必要です。",
      "編集部では生成画像を使う場合、読者が実写と誤認しない表示が有用です。"
    ],
    evidenceLimits: [
      "見た目が精密でも、生成画像の機構が実在するとは限りません。",
      "生成画像から可搬重量、速度、トルク、安全性を推定できません。"
    ],
    sourceIds: ["unitree", "figure", "apptronikApollo"],
    related: [
      { label: "人型ロボット", to: "/ja/humanoid-robots" },
      { label: "ロボティクス", to: "/ja/robotics" }
    ]
  },

  "/robotics-news/multi-robot-ai-collaboration": {
    ...common,
    reviewed: "2026-09-30",
    heading: "Multi-robot claims should report coordination cost as well as task completion",
    summary: "A team of robots can divide work, share maps or pass task state between agents, but collaboration adds communication delay, duplicated observations and new failure modes. A useful comparison records total task time, per-robot utilization, communication load, intervention count and what happens when one robot drops out.",
    verifiedFacts: [
      "ROS 2 provides communication primitives used in distributed robot systems, including topics, services and actions.",
      "Parallel robots can reduce elapsed task time only when work can be divided without excessive coordination or shared-resource conflicts.",
      "A fleet result should state whether robots share a central planner, distributed state or independent policies."
    ],
    evidenceLimits: [
      "A successful synchronized run does not show how the system behaves under packet loss, stale state or one robot failure.",
      "More robots can increase contention around doors, work cells, chargers and shared objects."
    ],
    sourceIds: ["ros2", "mujoco"],
    related: [
      { label: "robotics software", to: "/robotics-software" },
      { label: "robot learning", to: "/robotics-topics" }
    ]
  },
  "/robotics-news/zero-shot-robotics-physical-ai": {
    ...common,
    reviewed: "2026-09-30",
    heading: "Zero-shot needs a named axis: new object, new task, new scene or new robot body",
    summary: "The phrase zero-shot is too broad unless the experiment states what changed between training and evaluation. A robot may see a new object while using the same task, camera and embodiment, or it may face a new instruction on a familiar setup. This page now separates those cases so readers can judge the actual generalization claim.",
    verifiedFacts: [
      "Vision-language-action research such as GR00T N1 and Gemini Robotics evaluates models under defined robot, data and task setups.",
      "Generalization across objects or language instructions is a different test from transferring a policy to a robot with different joints, cameras or grippers.",
      "A useful report names the training distribution, held-out condition, number of trials and success criterion."
    ],
    evidenceLimits: [
      "A model can be zero-shot on one variable while relying on prior training that is close on several others.",
      "Benchmark generalization does not establish deployment reliability in uncontrolled environments."
    ],
    sourceIds: ["grootN1", "geminiRobotics"],
    related: [
      { label: "Physical AI", to: "/physical-ai" },
      { label: "robotics data collection", to: "/robotics-data-collection" }
    ]
  },
  "/robotics-news/self-evolving-embodied-ai": {
    ...common,
    reviewed: "2026-09-30",
    heading: "Continual robot learning needs versioned updates and a rollback path",
    summary: "A robot that changes its memory, world model or policy after deployment creates a verification problem: the system that passed yesterday's test may differ from the one running today. Useful evidence should record what changed, which data caused the update, what regression tests ran and whether the previous policy can be restored.",
    verifiedFacts: [
      "Robot behavior depends on both learned policy components and the surrounding control, perception and safety stack.",
      "Simulation can replay defined scenarios after an update, but real-robot checks are still needed for sensing, contact and hardware timing.",
      "Versioning model weights, configuration and evaluation results makes post-deployment changes easier to audit."
    ],
    evidenceLimits: [
      "Improvement on recent tasks can hide regressions on older skills or edge cases.",
      "Online adaptation without bounded tests can make failures harder to reproduce."
    ],
    sourceIds: ["mujoco", "isaacSim", "ros2"],
    related: [
      { label: "robot learning topics", to: "/robotics-topics" },
      { label: "Physical AI", to: "/physical-ai" }
    ]
  },
};

export function getRoboticsResearchEnhancement(pathname) {
  const clean = String(pathname || "/").replace(/\/+$/, "") || "/";
  const item = roboticsResearchEnhancements[clean];
  if (!item) return null;
  return {
    ...item,
    sources: (item.sourceIds || []).map((id) => roboticsResearchSources[id]).filter(Boolean)
  };
}
